(function () {
  'use strict';

  var GIFT_DEMO_PDP_URL = '/products/vanessa';

  /* Minicart promo modules — flip to true when ready to ship */
  var GIFT_CART_PROMO_FEATURES = {
    shippingUrgency: false,
    giftPicker: false,
    scarcityLabels: false,
    /* "We think you'll also love" in the mini cart. Off: the drawer goes
       straight from the line items to the subtotal. */
    upsell: false
  };

  /* PDP modules — flip to true in next phase */
  var GIFT_PDP_FEATURES = {
    perfectGiftUpsell: false,
    quizBanner: false,
    breadcrumb: false
  };

  function isDemoVariantId(value) {
    return String(value || '').indexOf('demo') === 0;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  function getColorSwatchStyle(colorName) {
    var name = String(colorName || '').toLowerCase().trim();
    if (name.indexOf('gold') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #F0D890 0%, #D4A858 55%, #B88838 100%)';
    }
    if (name.indexOf('cool ash blonde') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #D8CEB8 0%, #B8A88E 55%, #9A8A72 100%)';
    }
    if (name.indexOf('ash blonde') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #D6CCB4 0%, #B8A890 55%, #9E9078 100%)';
    }
    if (name.indexOf('honey blonde') !== -1 || name.indexOf('honey') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #E8C88A 0%, #D4A86A 55%, #B88848 100%)';
    }
    if (name.indexOf('dark brown') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #5A4030 0%, #3D2B20 55%, #2A1C14 100%)';
    }
    if (name.indexOf('mocha') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #7A5844 0%, #5A3D2E 55%, #3E2A1E 100%)';
    }
    if (name.indexOf('brunette') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #6A4A38 0%, #4A3228 55%, #322218 100%)';
    }
    if (name.indexOf('black') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #3A3028 0%, #221A16 55%, #100C0A 100%)';
    }
    if (name.indexOf('balayage') !== -1) {
      return 'background: linear-gradient(135deg, #4A3228 0%, #8A6848 38%, #C8A878 68%, #E8D8B8 100%)';
    }
    if (name.indexOf('auburn') !== -1 || name.indexOf('copper') !== -1 || name.indexOf('red') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #B85A40 0%, #8B3F2B 55%, #6A2E1E 100%)';
    }
    if (name.indexOf('blonde') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #E8DCC8 0%, #D4C4A0 55%, #B8A880 100%)';
    }
    if (name.indexOf('brown') !== -1) {
      return 'background: radial-gradient(circle at 32% 28%, #6A4E3C 0%, #4A3628 55%, #322418 100%)';
    }
    return 'background: radial-gradient(circle at 32% 28%, #D8D0C4 0%, #B8B0A4 55%, #989088 100%)';
  }

  function colorSwatchHtml(colorName) {
    return '<span class="gift-color-swatch" style="' + escapeAttr(getColorSwatchStyle(colorName)) + '" aria-hidden="true"></span>';
  }

  function getItemHandle(item) {
    if (item.handle) return item.handle;
    if (!item.url) return '';
    var match = String(item.url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function setCartMode(mode) {
    var root = document.getElementById('giftMiniCart');
    if (root) root.dataset.cartMode = mode;
  }

  function isDemoCartActive() {
    var root = document.getElementById('giftMiniCart');
    return !!(root && root.dataset.cartMode === 'demo');
  }

  function getCartExploreConfig() {
    var el = document.getElementById('giftCartExplore');
    if (!el) return { shop_url: '/collections/all', categories: [], bestsellers: [] };
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return { shop_url: '/collections/all', categories: [], bestsellers: [] };
    }
  }

  function buildExploreCategoryUrl(baseUrl, filterKey) {
    if (!filterKey || filterKey === 'all') return baseUrl;
    var joiner = String(baseUrl).indexOf('?') >= 0 ? '&' : '?';
    return baseUrl + joiner + 'category=' + encodeURIComponent(filterKey);
  }

  function buildEmptyBestsellerCard(product, index) {
    var html = '<article class="gift-cart__empty-product' + (index === 0 ? ' is-active' : '') + '" data-empty-product-index="' + index + '">';
    html += '<a href="' + escapeAttr(product.url) + '" class="gift-cart__empty-product-media" data-cart-explore>';
    html += '<img src="' + escapeAttr(product.image) + '" alt="" width="120" height="120" class="gift-cart__empty-product-img" loading="lazy">';
    html += '</a>';
    html += '<div class="gift-cart__empty-product-copy">';
    html += '<a href="' + escapeAttr(product.url) + '" class="gift-cart__empty-product-title" data-cart-explore>' + escapeHtml(product.title) + '</a>';
    if (product.subtitle) {
      html += '<p class="gift-cart__empty-product-subtitle">' + escapeHtml(product.subtitle) + '</p>';
    }
    html += '<p class="gift-cart__empty-product-price">' + money(product.price_cents || 0) + '</p>';
    html += '<button type="button" class="gift-cart__empty-product-add" data-upsell-handle="' + escapeAttr(product.handle) + '">Add to bag</button>';
    html += '</div></article>';
    return html;
  }

  function buildEmptyCartHtml() {
    var config = getCartExploreConfig();
    var html = '<div class="gift-cart__empty-state">';
    html += '<div class="gift-cart__empty-message">';
    html += '<p class="gift-cart__empty-title">Your bag is empty.</p>';
    html += '<p class="gift-cart__empty-lead">Explore our popular categories.</p>';
    html += '</div>';

    if (config.categories && config.categories.length) {
      html += '<nav class="gift-cart__empty-categories" aria-label="Shop categories">';
      config.categories.forEach(function (category) {
        var href = buildExploreCategoryUrl(config.shop_url, category.filter);
        html += '<a href="' + escapeAttr(href) + '" class="gift-cart__empty-category" data-cart-explore>' + escapeHtml(category.label) + '</a>';
      });
      html += '</nav>';
    }

    var bestsellers = config.bestsellers || [];
    if (bestsellers.length) {
      html += '<section class="gift-cart__empty-bestsellers" aria-label="Shop best sellers">';
      html += '<div class="gift-cart__empty-bestsellers-head">';
      html += '<h3 class="gift-cart__empty-bestsellers-title">Shop best sellers</h3>';
      html += '<div class="gift-cart__empty-bestsellers-nav">';
      html += '<button type="button" class="gift-cart__empty-bestsellers-btn" data-empty-carousel-prev aria-label="Previous product" disabled>';
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M10 3 5 8l5 5"/></svg>';
      html += '</button>';
      html += '<button type="button" class="gift-cart__empty-bestsellers-btn" data-empty-carousel-next aria-label="Next product"' + (bestsellers.length <= 1 ? ' disabled' : '') + '>';
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg>';
      html += '</button></div></div>';
      html += '<div class="gift-cart__empty-bestsellers-track" id="giftCartEmptyBestsellersTrack">';
      bestsellers.forEach(function (product, index) {
        html += buildEmptyBestsellerCard(product, index);
      });
      html += '</div></section>';
    }

    html += '</div>';
    return html;
  }

  var emptyCartCarouselIndex = 0;

  function setEmptyCartCarousel(index) {
    var track = document.getElementById('giftCartEmptyBestsellersTrack');
    if (!track) return;

    var cards = track.querySelectorAll('.gift-cart__empty-product');
    if (!cards.length) return;

    var nextIndex = Math.max(0, Math.min(index, cards.length - 1));
    emptyCartCarouselIndex = nextIndex;

    cards.forEach(function (card, cardIndex) {
      card.classList.toggle('is-active', cardIndex === nextIndex);
    });

    var prevBtn = document.querySelector('[data-empty-carousel-prev]');
    var nextBtn = document.querySelector('[data-empty-carousel-next]');
    if (prevBtn) prevBtn.disabled = nextIndex <= 0;
    if (nextBtn) nextBtn.disabled = nextIndex >= cards.length - 1;
  }

  function initEmptyCartCarousel() {
    emptyCartCarouselIndex = 0;
    setEmptyCartCarousel(0);
  }

  function getUpsellCatalog() {
    var el = document.getElementById('giftCartUpsells');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return [];
    }
  }

  function getCartGifts() {
    var el = document.getElementById('giftCartGifts');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return [];
    }
  }

  function getGiftHandles() {
    return getCartGifts().map(function (gift) { return gift.handle; });
  }

  function cartHasComplimentaryGift(cart) {
    var giftHandles = getGiftHandles();
    return getCartHandles(cart).some(function (handle) {
      return giftHandles.indexOf(handle) !== -1;
    });
  }

  function syncGiftPickerSelection() {
    var select = document.getElementById('giftCartGiftSelect');
    var image = document.getElementById('giftCartGiftImage');
    var details = document.getElementById('giftCartGiftDetails');
    if (!select) return;

    var gift = getCartGifts().find(function (entry) {
      return entry.handle === select.value;
    }) || getCartGifts()[0];

    if (!gift) return;
    if (image) {
      image.src = gift.image;
      image.alt = gift.title || gift.label || 'Complimentary gift';
    }
    if (details) details.href = gift.details_url || gift.url || '#';
  }

  function updateGiftPromo(cart) {
    var promo = document.getElementById('giftCartGiftPromo');
    if (!promo) return;
    if (!GIFT_CART_PROMO_FEATURES.giftPicker) {
      promo.hidden = true;
      return;
    }
    promo.hidden = !cart.item_count || cartHasComplimentaryGift(cart);
  }

  function updateCartSubtotal(totalCents) {
    var subtotal = document.getElementById('giftCartSubtotal');
    if (subtotal) subtotal.textContent = money(totalCents || 0);
  }

  function addDemoGift(gift) {
    var cart = getDemoCart();
    var variantId = 'demo-gift-' + gift.handle;
    if (cart.items.some(function (item) { return item.variant_id === variantId; })) {
      return renderCart(demoCartPayload());
    }

    cart.items.push({
      product_title: gift.title,
      variant_title: gift.variant_label || '',
      variant_id: variantId,
      handle: gift.handle,
      quantity: 1,
      price: 0,
      final_line_price: 0,
      image: gift.image,
      url: gift.url || '#',
      key: variantId
    });
    saveDemoCart(cart);
    setCartMode('demo');
    return renderCart(demoCartPayload());
  }

  function addGiftByHandle(handle) {
    var gift = getCartGifts().find(function (entry) { return entry.handle === handle; });
    if (!gift) return Promise.resolve();

    var addBtn = document.getElementById('giftCartGiftAdd');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
    }

    function finishGiftAdd() {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      }
    }

    if (isDemoCartActive()) {
      return Promise.resolve(addDemoGift(gift)).finally(finishGiftAdd);
    }

    return fetch('/products/' + gift.handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('gift unavailable');
        return response.json();
      })
      .then(function (productData) {
        var variant = productData.variants.find(function (entry) { return entry.available; }) || productData.variants[0];
        if (!variant) throw new Error('gift variant unavailable');
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: (function () {
            var fd = new FormData();
            fd.append('id', variant.id);
            fd.append('quantity', '1');
            fd.append('properties[_complimentary_gift]', 'yes');
            return fd;
          })()
        }).then(function (response) {
          if (!response.ok) throw new Error('gift add failed');
          return response.json();
        });
      })
      .then(function () {
        setCartMode('shopify');
        return refreshCart();
      })
      .catch(function () {
        return addDemoGift(gift);
      })
      .finally(finishGiftAdd);
  }

  function initGiftPicker() {
    var select = document.getElementById('giftCartGiftSelect');
    var addBtn = document.getElementById('giftCartGiftAdd');
    var gifts = getCartGifts();
    if (!select || !gifts.length) return;

    select.innerHTML = gifts.map(function (gift) {
      return '<option value="' + escapeAttr(gift.handle) + '">' + escapeHtml(gift.label) + '</option>';
    }).join('');

    if (select.dataset.giftPickerBound !== 'true') {
      select.dataset.giftPickerBound = 'true';
      select.addEventListener('change', syncGiftPickerSelection);
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addGiftByHandle(select.value);
        });
      }
    }

    syncGiftPickerSelection();
  }

  function getCartHandles(cart) {
    return (cart.items || []).map(getItemHandle).filter(Boolean);
  }

  function buildGiftPromoHtml() {
    if (!GIFT_CART_PROMO_FEATURES.giftPicker) return '';

    var gifts = getCartGifts();
    var defaultGift = gifts[0] || {};
    var image = defaultGift.image || '';
    var detailsUrl = defaultGift.details_url || defaultGift.url || '/pages/care-and-learn';

    var html = '<section class="gift-cart__gift-promo" id="giftCartGiftPromo" hidden aria-label="Complimentary gift">';
    html += '<p class="gift-cart__gift-promo-head">';
    html += 'CHOOSE your gift&mdash;<strong>satin scrunchie</strong> or <strong>deluxe sample</strong> with every purchase &lt;3';
    html += '</p>';
    html += '<div class="gift-cart__gift-card">';
    html += '<div class="gift-cart__gift-media">';
    html += '<img id="giftCartGiftImage" src="' + escapeAttr(image) + '" alt="" width="56" height="72" class="gift-cart__gift-img" loading="lazy">';
    html += '</div>';
    html += '<div class="gift-cart__gift-main">';
    html += '<p class="gift-cart__gift-label">Select your gift</p>';
    html += '<div class="gift-cart__gift-picker">';
    html += '<select id="giftCartGiftSelect" class="gift-cart__gift-select" aria-label="Select your gift"></select>';
    html += '</div></div>';
    html += '<div class="gift-cart__gift-actions">';
    html += '<button type="button" class="gift-cart__gift-add" id="giftCartGiftAdd">Add gift</button>';
    html += '<a href="' + escapeAttr(detailsUrl) + '" class="gift-cart__gift-details" id="giftCartGiftDetails">More details</a>';
    html += '</div></div></section>';
    return html;
  }

  function buildUpsellHtml(cart) {
    if (!GIFT_CART_PROMO_FEATURES.upsell) return '';

    var inCart = getCartHandles(cart);
    var picks = getUpsellCatalog().filter(function (product) {
      return inCart.indexOf(product.handle) === -1;
    }).slice(0, 2);

    if (!picks.length) return '';

    var html = '<section class="gift-cart__upsell" aria-label="Recommended products">';
    html += '<h3 class="gift-cart__upsell-title">We think you&rsquo;ll also love&hellip;</h3>';
    html += '<div class="gift-cart__upsell-grid">';
    picks.forEach(function (product) {
      html += '<article class="gift-cart__upsell-card">';
      html += '<a href="' + escapeAttr(product.url) + '" class="gift-cart__upsell-media">';
      html += '<img src="' + escapeAttr(product.image) + '" alt="" width="220" height="220" class="gift-cart__upsell-img" loading="lazy">';
      html += '</a>';
      html += '<div class="gift-cart__upsell-copy">';
      html += '<a href="' + escapeAttr(product.url) + '" class="gift-cart__upsell-name">' + escapeHtml(product.title) + '</a>';
      html += '<p class="gift-cart__upsell-price">' + money(product.price_cents || 0) + '</p>';
      html += '<button type="button" class="gift-cart__upsell-add" data-upsell-handle="' + escapeAttr(product.handle) + '">Add</button>';
      html += '</div></article>';
    });
    html += '</div></section>';
    return html;
  }

  function addDemoUpsell(product) {
    var cart = getDemoCart();
    var variantId = 'demo-' + product.handle;
    var lineKey = (product.handle || 'upsell') + '--' + variantId;
    var existing = cart.items.find(function (item) { return String(item.key) === String(lineKey); });
    if (existing) {
      existing.quantity += 1;
      existing.final_line_price = existing.price * existing.quantity;
    } else {
      cart.items.push({
        product_title: product.title,
        variant_title: '',
        variant_id: variantId,
        handle: product.handle,
        quantity: 1,
        price: product.price_cents || 0,
        final_line_price: product.price_cents || 0,
        image: product.image,
        url: product.url,
        key: lineKey
      });
    }
    saveDemoCart(cart);
    setCartMode('demo');
    return renderCart(demoCartPayload());
  }

  function findCartProductByHandle(handle) {
    var product = getUpsellCatalog().find(function (entry) { return entry.handle === handle; });
    if (product) return product;
    var explore = getCartExploreConfig();
    return (explore.bestsellers || []).find(function (entry) { return entry.handle === handle; });
  }

  function addUpsellByHandle(handle) {
    var product = findCartProductByHandle(handle);
    if (!product) return Promise.resolve();

    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('product unavailable');
        return response.json();
      })
      .then(function (productData) {
        var variant = productData.variants.find(function (entry) { return entry.available; }) || productData.variants[0];
        if (!variant) throw new Error('variant unavailable');
        var fd = new FormData();
        fd.append('id', variant.id);
        return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        });
      })
      .then(function () {
        setCartMode('shopify');
        return refreshCart();
      })
      .catch(function () {
        return addDemoUpsell(product);
      });
  }

  function getCartLineKey(item, index) {
    return item.key || item.variant_id || String(index);
  }

  function buildCartItemHtml(item, index) {
    var lineKey = getCartLineKey(item, index);
    var qty = item.quantity || 1;
    var unitPrice = item.price || Math.round((item.final_line_price || 0) / Math.max(qty, 1));
    var variantLabel = formatCartVariantLabel(item);
    var html = '<li class="gift-cart__item" data-cart-line="' + escapeAttr(lineKey) + '">';

    if (item.image) {
      html += '<a href="' + escapeAttr(item.url || '#') + '" class="gift-cart__item-media">';
      html += '<img src="' + escapeAttr(item.image) + '" alt="" width="110" height="110" class="gift-cart__item-img">';
      html += '</a>';
    } else {
      html += '<span class="gift-cart__item-media gift-cart__item-media--placeholder" aria-hidden="true"></span>';
    }

    html += '<div class="gift-cart__item-main">';
    html += '<div class="gift-cart__item-top">';
    html += '<a href="' + escapeAttr(item.url || '#') + '" class="gift-cart__item-title">' + escapeHtml(item.product_title) + '</a>';
    html += '<div class="gift-cart__item-price">' + money(item.final_line_price || unitPrice * qty) + '</div>';
    html += '</div>';

    if (variantLabel) {
      html += '<p class="gift-cart__item-variant">';
      html += '<span>' + escapeHtml(variantLabel) + '</span>';
      if (item.url && item.url !== '#') {
        html += ' <a href="' + escapeAttr(item.url) + '" class="gift-cart__item-edit">Edit</a>';
      }
      html += '</p>';
    }

    if (GIFT_CART_PROMO_FEATURES.scarcityLabels && item.scarcity_label) {
      html += '<p class="gift-cart__scarcity"><span class="gift-cart__scarcity-dot" aria-hidden="true"></span>' + escapeHtml(item.scarcity_label) + '</p>';
    }

    html += '<div class="gift-cart__qty" data-cart-qty>';
    html += '<button type="button" class="gift-cart__qty-btn" data-cart-dec data-line-key="' + escapeAttr(lineKey) + '" data-qty="' + qty + '" aria-label="' + (qty <= 1 ? 'Remove item' : 'Decrease quantity') + '">&minus;</button>';
    html += '<span class="gift-cart__qty-value" aria-live="polite">' + qty + '</span>';
    html += '<button type="button" class="gift-cart__qty-btn" data-cart-inc data-line-key="' + escapeAttr(lineKey) + '" data-qty="' + qty + '" aria-label="Increase quantity">+</button>';
    html += '</div></div></li>';

    return html;
  }

  function updateCartLine(lineKey, quantity) {
    if (isDemoCartActive()) {
      var cart = getDemoCart();
      var item = cart.items.find(function (entry) {
        return String(getCartLineKey(entry)) === String(lineKey);
      });
      if (!item) return refreshCart();
      if (quantity <= 0) {
        cart.items = cart.items.filter(function (entry) {
          return String(getCartLineKey(entry)) !== String(lineKey);
        });
      } else {
        item.quantity = quantity;
        item.final_line_price = item.price * quantity;
      }
      saveDemoCart(cart);
      setCartMode('demo');
      return renderCart(demoCartPayload());
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then(function (cart) {
        setCartMode('shopify');
        return renderCart(cart);
      })
      .catch(function () {
        return refreshCart();
      });
  }

  var bodyScrollLock = (function () {
    var lockCount = 0;

    function lock() {
      if (lockCount === 0) {
        document.documentElement.classList.add('gift-scroll-lock');
        document.body.classList.add('gift-scroll-lock');
      }
      lockCount += 1;
    }

    function unlock() {
      if (lockCount <= 1) {
        lockCount = 0;
        document.documentElement.classList.remove('gift-scroll-lock');
        document.body.classList.remove('gift-scroll-lock');
      } else {
        lockCount -= 1;
      }
    }

    return { lock: lock, unlock: unlock };
  })();

  function initHeaderOffset() {
    var wrap = document.getElementById('giftHeaderWrap');
    if (!wrap) return;
    var height = wrap.offsetHeight;
    document.documentElement.style.setProperty('--g-header-offset', height + 'px');
    document.documentElement.style.setProperty('--g-header-h', height + 'px');
    try { sessionStorage.setItem('gift:header-h', String(height)); } catch (error) {}
  }

  function initLogoHomeScroll() {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    function isHomePath(pathname) {
      return pathname === '/' || pathname === '';
    }

    function scrollHomeTop() {
      window.scrollTo(0, 0);
    }

    function markHomeScrollTop() {
      try {
        sessionStorage.setItem('giftScrollHomeTop', '1');
      } catch (error) {
        /* ignore */
      }
    }

    function consumeHomeScrollTop() {
      try {
        if (sessionStorage.getItem('giftScrollHomeTop') !== '1') return false;
        sessionStorage.removeItem('giftScrollHomeTop');
        return true;
      } catch (error) {
        return false;
      }
    }

    document.querySelectorAll('a.gift-header__logo, a.gift-header__logo-lockup').forEach(function (logo) {
      logo.addEventListener('click', function (event) {
        var href = logo.getAttribute('href');
        if (!href) return;

        var targetUrl;
        try {
          targetUrl = new URL(href, window.location.origin);
        } catch (error) {
          return;
        }

        if (!isHomePath(targetUrl.pathname)) return;

        var onHome =
          isHomePath(window.location.pathname) &&
          targetUrl.pathname === window.location.pathname &&
          targetUrl.search === window.location.search;

        if (onHome) {
          event.preventDefault();
          if (window.location.hash) {
            history.replaceState(null, '', targetUrl.pathname + targetUrl.search);
          }
          scrollHomeTop();
          return;
        }

        markHomeScrollTop();
      });
    });

    if (isHomePath(window.location.pathname) && !window.location.hash && consumeHomeScrollTop()) {
      scrollHomeTop();
    }

    window.addEventListener('pageshow', function (event) {
      if (!isHomePath(window.location.pathname) || window.location.hash) return;
      if (event.persisted || consumeHomeScrollTop()) {
        scrollHomeTop();
      }
    });
  }

  function initNavDrawer() {
    var menuBtn = document.getElementById('giftMenuBtn');
    var searchOpen = document.getElementById('giftSearchOpen');
    var nav = document.getElementById('giftNav');
    var closeBtn = document.getElementById('giftNavClose');
    var searchFocusBtn = document.getElementById('giftNavSearchFocus');
    var searchInput = document.getElementById('giftNavSearchInput');
    var miniCart = document.getElementById('giftMiniCart');

    function isNavOpen() {
      return nav && nav.getAttribute('aria-hidden') === 'false';
    }

    function setBodyLock(locked) {
      if (locked) bodyScrollLock.lock();
      else if (!miniCart || miniCart.getAttribute('aria-hidden') !== 'false') bodyScrollLock.unlock();
    }

    function openNav(focusSearch) {
      if (!nav) return;
      nav.setAttribute('aria-hidden', 'false');
      nav.classList.toggle('is-search-mode', !!focusSearch);
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      setBodyLock(true);
      if (focusSearch && searchInput) {
        setTimeout(function () { searchInput.focus(); }, 320);
      }
    }

    function closeNav() {
      if (!nav) return;
      nav.setAttribute('aria-hidden', 'true');
      nav.classList.remove('is-search-mode');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      setBodyLock(false);
    }

    window.closeNav = closeNav;

    if (menuBtn) menuBtn.addEventListener('click', function () {
      if (isNavOpen()) closeNav();
      else openNav(false);
    });

    if (searchOpen) searchOpen.addEventListener('click', function () { openNav(true); });
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (searchFocusBtn && searchInput) {
      searchFocusBtn.addEventListener('click', function () {
        nav.classList.add('is-search-mode');
        searchInput.focus();
      });
    }
    if (searchInput) {
      searchInput.addEventListener('focus', function () {
        nav.classList.add('is-search-mode');
      });
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        if (e.target === nav) closeNav();
      });

      nav.querySelectorAll('a:not([data-close-nav])').forEach(function (link) {
        link.addEventListener('click', closeNav);
      });

      nav.querySelectorAll('[data-close-nav]').forEach(function (link) {
        link.addEventListener('click', closeNav);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isNavOpen()) closeNav();
    });
  }

  function getDemoCart() {
    try {
      var raw = sessionStorage.getItem('giftDemoCart');
      return raw ? JSON.parse(raw) : { items: [] };
    } catch (e) {
      return { items: [] };
    }
  }

  function saveDemoCart(cart) {
    try {
      sessionStorage.setItem('giftDemoCart', JSON.stringify(cart));
    } catch (e) {}
  }

  function getFormDemoImage(form) {
    if (!form) return '';
    var image = form.dataset.demoImage || '';
    if (image) return image;

    var quickPanel = form.closest('[data-card-quick-add]');
    var quickImage = quickPanel ? quickPanel.querySelector('[data-quick-add-image]') : null;
    if (quickImage && quickImage.src) return quickImage.src;

    var card = form.closest('.gift-shop-card');
    if (card) {
      var cardImg = card.querySelector('.gift-shop-card__img');
      if (cardImg && cardImg.src) return cardImg.src;
    }

    var upsellCard = form.closest('.gift-pdp__upsell-card');
    if (upsellCard) {
      var upsellImg = upsellCard.querySelector('.gift-pdp__upsell-img');
      if (upsellImg && upsellImg.src) return upsellImg.src;
    }

    if (form.id === 'giftPdpForm' || form.classList.contains('gift-pdp__form')) {
      var imageEl = document.querySelector('.gift-pdp__media.is-active img') || document.querySelector('.gift-pdp__media img');
      if (imageEl && imageEl.src) return imageEl.src;
    }

    return '';
  }

  var DEMO_CART_IMAGE_BY_TITLE = {
    'gift care kit': 'gift-brand-05-tray.jpg',
    'silk straight ponytail': 'gift-brand-02-mirror.jpg',
    'silk scarf': 'gift-product-card-383.jpg',
    'wig grip band': 'gift-product-card-383.jpg',
    'satin scrunchie': 'gift-product-card-383.jpg',
    'deluxe sample': 'gift-product-card-383.jpg'
  };

  var DEMO_CART_IMAGE_BY_HANDLE = {
    vanessa: 'gift-product-vanessa-model-01.jpg',
    bianca: 'gift-product-bianca-model-01.jpg',
    chinonye: 'gift-product-chinonye-model-01.jpg',
    lily: 'gift-product-lily-model-01.jpg',
    melody: 'gift-product-melody-model-01.jpg',
    victoria: 'gift-product-victoria-model-01.jpg',
    yasmin: 'gift-product-yasmin-model-01.jpg',
    'gift-care-kit': 'gift-brand-05-tray.jpg',
    'silk-straight-ponytail': 'gift-brand-02-mirror.jpg'
  };

  function resolveDemoCartItemImage(item) {
    if (!item) return item;
    var title = String(item.product_title || '').toLowerCase().trim();
    var handle = item.handle || getItemHandle(item);
    if (!handle && title) {
      handle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    var asset = DEMO_CART_IMAGE_BY_TITLE[title] || (handle ? DEMO_CART_IMAGE_BY_HANDLE[handle] : '');
    if (asset) {
      return Object.assign({}, item, { image: themeAssetUrl(asset) });
    }
    return item;
  }

  function demoCartPayload() {
    var items = getDemoCart().items.map(function (item) {
      return resolveDemoCartItemImage(Object.assign({}, item, { key: item.key || item.variant_id }));
    });
    var subtotal = items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    return {
      item_count: items.reduce(function (sum, item) { return sum + item.quantity; }, 0),
      items: items,
      items_subtotal_price: subtotal,
      total_price: subtotal
    };
  }

  function parsePriceCents(text) {
    if (!text) return 0;
    var match = String(text).replace(/,/g, '').match(/([0-9]+(?:\.[0-9]{1,2})?)/);
    return match ? Math.round(parseFloat(match[1]) * 100) : 0;
  }

  function getCardVariantTitle(root) {
    if (!root) return '';
    var parts = [];
    var inputs;

    if (root.hasAttribute('data-quick-add-form') || root.classList.contains('gift-card-quick-add__form')) {
      inputs = root.querySelectorAll('[data-quick-add-option]:checked');
    } else if (root.closest) {
      var card = root.closest('[data-plp-card]');
      if (card) {
        inputs = card.querySelectorAll('[data-plp-preview-swatch].is-active');
      }
    }

    if (!inputs || !inputs.length) {
      inputs = root.querySelectorAll ? root.querySelectorAll('[data-plp-preview-swatch].is-active, [data-plp-option-input]:checked, [data-option-input]:checked') : [];
    }

    inputs.forEach(function (input) {
      parts.push(input.value || input.getAttribute('data-preview-value') || '');
    });
    return parts.filter(Boolean).join(' · ');
  }

  function formatCartVariantLabel(item) {
    var label = item && item.variant_title;
    if (!label || label === 'Default Title') return '';
    return String(label).replace(/\s*\/\s*/g, ' · ').trim();
  }

  function addDemoFromForm(form) {
    var card = form.closest('.gift-shop-card');
    var quickPanel = form.closest('[data-card-quick-add]');
    var quickTitle = quickPanel ? quickPanel.querySelector('[data-quick-add-title]') : null;
    var quickPrice = quickPanel ? quickPanel.querySelector('[data-quick-add-price]') : null;
    var titleEl = document.querySelector('.gift-pdp__title');
    var title = form.dataset.demoTitle || '';
    if (!title && quickTitle) title = quickTitle.textContent.trim();
    if (!title && card) {
      var cardTitle = card.querySelector('.gift-shop-card__title a, .gift-shop-card__title');
      title = cardTitle ? cardTitle.textContent.trim() : '';
    }
    if (!title && titleEl) title = titleEl.textContent.trim();
    if (!title) title = 'Product';

    var priceEl = document.getElementById('giftPdpPrice');
    var priceText = form.dataset.demoPrice || '';
    if (!priceText && quickPrice) {
      priceText = quickPrice.getAttribute('data-price-text') || quickPrice.textContent;
    }
    if (!priceText && card) {
      var cardPrice = card.querySelector('.gift-shop-card__price-sale, .gift-shop-card__price > span');
      priceText = cardPrice ? cardPrice.textContent : (card.querySelector('.gift-shop-card__price') || {}).textContent || '';
    }
    if (!priceText && priceEl) {
      var priceNode = priceEl.querySelector('.gift-pdp__price-sale') || priceEl.querySelector('span');
      priceText = priceNode ? priceNode.textContent : priceEl.textContent;
    }
    var priceCents = parsePriceCents(priceText);

    var image = getFormDemoImage(form);

    var variantTitle = '';
    if (form.hasAttribute('data-quick-add-form')) {
      variantTitle = getCardVariantTitle(form);
    } else if (form.id === 'giftPdpForm' || form.classList.contains('gift-pdp__form')) {
      variantTitle = getCardVariantTitle(form);
    } else {
      var labelEl = document.getElementById('giftPdpSelectedLabel');
      if (labelEl) variantTitle = labelEl.textContent.trim();
      else if (card) {
        variantTitle = getCardVariantTitle(card);
        if (!variantTitle) {
          var cardSubtitle = card.querySelector('.gift-shop-card__variants');
          variantTitle = cardSubtitle ? cardSubtitle.textContent.trim() : '';
        }
      }
    }

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? idInput.value : 'demo';

    var demoUrl = form.dataset.demoUrl || '';
    if (!demoUrl) {
      var quickPdp = quickPanel ? quickPanel.querySelector('[data-quick-add-pdp-link]') : null;
      demoUrl = quickPdp ? quickPdp.href : '';
    }
    if (!demoUrl && card) {
      var cardLink = card.querySelector('.gift-shop-card__title a');
      demoUrl = cardLink ? cardLink.href : '';
    }

    var cart = getDemoCart();
    var productHandle = '';
    if (form.dataset.demoTitle && (form.classList.contains('gift-pdp__upsell-form') || form.closest('.gift-pdp__upsell-card'))) {
      productHandle = String(form.dataset.demoTitle).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    if (!productHandle) productHandle = getItemHandle({ url: demoUrl || '#' });
    if (!productHandle && title) {
      productHandle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    var lineKey = (productHandle || 'product') + '--' + variantId;
    var existing = cart.items.find(function (item) {
      return String(item.key) === String(lineKey);
    });
    if (existing) {
      existing.quantity += 1;
      existing.final_line_price = existing.price * existing.quantity;
    } else {
      cart.items.push({
        product_title: title,
        variant_title: variantTitle,
        variant_id: variantId,
        handle: productHandle,
        quantity: 1,
        price: priceCents,
        final_line_price: priceCents,
        image: image,
        url: demoUrl || GIFT_DEMO_PDP_URL,
        key: lineKey
      });
    }

    saveDemoCart(cart);
    return demoCartPayload();
  }

  function handleDemoAddToCart(form, submitBtn) {
    if (!form) return;
    var btn = submitBtn || form.querySelector('button[type="submit"]');
    setAddLoading(btn, true);
    window.setTimeout(function () {
      var demoCart = addDemoFromForm(form);
      setCartMode('demo');
      renderCart(demoCart)
        .then(function () {
          if (form.hasAttribute('data-quick-add-form')) {
            closeCardQuickAdd(form.closest('[data-plp-card]'));
          }
          openCart({ justAdded: true, skipRefresh: true });
        })
        .finally(function () {
          setAddLoading(btn, false);
        });
    }, 380);
  }

  function isCartOpen() {
    var cart = document.getElementById('giftMiniCart');
    return cart && cart.getAttribute('aria-hidden') === 'false';
  }

  function setAddLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    }
  }

  function updateCartCheckoutState(totalCents) {
    var terms = document.getElementById('giftCartTerms');
    var checkout = document.getElementById('giftCartCheckout');
    var checkoutPrice = document.getElementById('giftCartCheckoutPrice');
    if (!terms || !checkout) return;

    var accepted = terms.checked;
    checkout.setAttribute('aria-disabled', accepted ? 'false' : 'true');
    checkout.tabIndex = accepted ? 0 : -1;
    if (typeof totalCents === 'number' && checkoutPrice) {
      checkoutPrice.textContent = money(totalCents);
    }
    if (accepted) {
      var error = document.getElementById('giftCartTermsError');
      if (error) error.hidden = true;
    }
  }

  function resetCartTerms() {
    var terms = document.getElementById('giftCartTerms');
    if (!terms) return;
    terms.checked = false;
    updateCartCheckoutState(0);
    var error = document.getElementById('giftCartTermsError');
    if (error) error.hidden = true;
  }

  function getCartUrgencyConfig() {
    var root = document.getElementById('giftMiniCart');
    if (!root) {
      return {
        freeShippingThreshold: 15000,
        cutoffHour: 14,
        cutoffMinute: 0,
        timezone: 'America/Chicago',
        lowStockThreshold: 5
      };
    }

    return {
      freeShippingThreshold: parseInt(root.dataset.freeShippingThreshold || '15000', 10),
      cutoffHour: parseInt(root.dataset.shippingCutoffHour || '14', 10),
      cutoffMinute: parseInt(root.dataset.shippingCutoffMinute || '0', 10),
      timezone: root.dataset.shippingTimezone || 'America/Chicago',
      lowStockThreshold: parseInt(root.dataset.lowStockThreshold || '5', 10)
    };
  }

  function getZonedCartTime(config) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: config.timezone,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    var map = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });

    return {
      weekday: map.weekday || '',
      hour: parseInt(map.hour || '0', 10),
      minute: parseInt(map.minute || '0', 10)
    };
  }

  function cartCheckIcon() {
    return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  }

  function cartClockIcon() {
    return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';
  }

  function getShippingCutoffMessage(config) {
    var zoned = getZonedCartTime(config);
    var weekend = zoned.weekday === 'Sat' || zoned.weekday === 'Sun';
    if (weekend) {
      return {
        text: 'Orders placed today ship Monday.',
        html: '<span class="gift-cart__promo-icon" aria-hidden="true">' + cartClockIcon() + '</span><span>Orders placed today ship <strong>Monday</strong>.</span>'
      };
    }

    var nowMinutes = zoned.hour * 60 + zoned.minute;
    var cutoffMinutes = config.cutoffHour * 60 + config.cutoffMinute;
    if (nowMinutes >= cutoffMinutes) {
      return {
        text: 'Orders placed now ship the next business day.',
        html: '<span class="gift-cart__promo-icon" aria-hidden="true">' + cartClockIcon() + '</span><span>Orders placed now ship the <strong>next business day</strong>.</span>'
      };
    }

    var remaining = cutoffMinutes - nowMinutes;
    var hours = Math.floor(remaining / 60);
    var mins = remaining % 60;
    var timeLabel = hours > 0 ? (hours + 'h ' + mins + 'm') : (mins + 'm');

    return {
      text: 'Order within ' + timeLabel + ' for same-day dispatch.',
      html: '<span class="gift-cart__promo-icon" aria-hidden="true">' + cartClockIcon() + '</span><span>Order within <strong>' + timeLabel + '</strong> for same-day dispatch.</span>'
    };
  }

  function getFreeShippingState(subtotalCents, config) {
    var threshold = config.freeShippingThreshold;
    var remaining = Math.max(threshold - subtotalCents, 0);
    var progress = Math.min(Math.round((subtotalCents / threshold) * 100), 100);
    var unlocked = subtotalCents >= threshold;

    return {
      threshold: threshold,
      remaining: remaining,
      progress: progress,
      unlocked: unlocked,
      label: unlocked
        ? 'You\u2019ve unlocked free shipping'
        : ('You\u2019re ' + money(remaining) + ' away from free shipping'),
      labelHtml: unlocked
        ? '<span class="gift-cart__promo-icon" aria-hidden="true">' + cartCheckIcon() + '</span><span>You\u2019ve unlocked <strong>free shipping</strong></span>'
        : ('<span>You\u2019re <strong>' + money(remaining) + '</strong> away from <strong>free shipping</strong></span>')
    };
  }

  function fetchVariantInventory(variantId) {
    if (!variantId || String(variantId).indexOf('demo') !== -1) {
      return Promise.resolve(null);
    }

    return fetch('/variants/' + variantId + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function getScarcityLabel(variant, config) {
    if (!variant) return '';
    if (variant.inventory_management !== 'shopify') return '';
    if (variant.inventory_policy !== 'deny') return '';

    var quantity = variant.inventory_quantity;
    if (typeof quantity !== 'number' || quantity <= 0) return '';
    if (quantity > config.lowStockThreshold) return '';

    return quantity === 1
      ? 'Low stock — 1 left in this shade'
      : ('Low stock — ' + quantity + ' left in this shade');
  }

  function getDemoScarcityLabel(item, config) {
    if (item.scarcity_label) return item.scarcity_label;

    var quantity = item.inventory_quantity;
    if (typeof quantity === 'number' && quantity > 0 && quantity <= config.lowStockThreshold) {
      return quantity === 1
        ? 'Low stock — 1 left in this shade'
        : ('Low stock — ' + quantity + ' left in this shade');
    }

    return 'Low stock — 3 left in this shade';
  }

  function isDemoVariantId(variantId) {
    return !variantId || String(variantId).indexOf('demo') === 0;
  }

  function enrichCartItems(items) {
    var config = getCartUrgencyConfig();
    var variantIds = [];

    items.forEach(function (item) {
      if (item.variant_id && !isDemoVariantId(item.variant_id) && variantIds.indexOf(item.variant_id) === -1) {
        variantIds.push(item.variant_id);
      }
    });

    if (!variantIds.length) {
      return Promise.resolve(items.map(function (item) {
        return Object.assign({}, item, {
          scarcity_label: GIFT_CART_PROMO_FEATURES.scarcityLabels ? getDemoScarcityLabel(item, config) : ''
        });
      }));
    }

    return Promise.all(variantIds.map(function (variantId) {
      return fetchVariantInventory(variantId).then(function (variant) {
        return { variantId: variantId, variant: variant };
      });
    })).then(function (results) {
      var variantMap = {};
      results.forEach(function (result) {
        variantMap[result.variantId] = result.variant;
      });

      return items.map(function (item) {
        if (isDemoVariantId(item.variant_id)) {
          return Object.assign({}, item, {
            scarcity_label: GIFT_CART_PROMO_FEATURES.scarcityLabels ? getDemoScarcityLabel(item, config) : ''
          });
        }

        var variant = variantMap[item.variant_id] || null;
        return Object.assign({}, item, {
          scarcity_label: GIFT_CART_PROMO_FEATURES.scarcityLabels ? getScarcityLabel(variant, config) : ''
        });
      });
    });
  }

  function updateCartItemCount(count) {
    var badge = document.getElementById('giftCartCountBadge');
    if (!badge) return;
    if (!count) {
      badge.hidden = true;
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = '';
      return;
    }
    badge.hidden = false;
    badge.setAttribute('aria-hidden', 'false');
    badge.textContent = String(count);
  }

  function updateCartUrgency(cart) {
    var shippingBlock = document.getElementById('giftCartShippingBlock');
    var topDivider = document.getElementById('giftCartTopDivider');
    if (!shippingBlock) return;

    if (!GIFT_CART_PROMO_FEATURES.shippingUrgency || !cart.item_count) {
      shippingBlock.hidden = true;
      if (topDivider) topDivider.hidden = true;
      return;
    }

    var config = getCartUrgencyConfig();
    var shipping = getFreeShippingState(cart.items_subtotal_price || 0, config);
    var label = document.getElementById('giftCartShippingLabel');
    var fill = document.getElementById('giftCartShippingFill');
    var progress = document.getElementById('giftCartShippingProgress');
    var root = document.getElementById('giftMiniCart');

    if (label) {
      label.innerHTML = shipping.labelHtml || shipping.label;
      label.classList.toggle('is-unlocked', shipping.unlocked);
    }
    if (fill) fill.style.width = shipping.progress + '%';
    if (progress) {
      progress.setAttribute('aria-valuenow', String(cart.items_subtotal_price || 0));
      progress.setAttribute('aria-valuemax', String(shipping.threshold));
      progress.classList.toggle('is-complete', shipping.unlocked);
    }
    var cutoffTop = document.getElementById('giftCartCutoffTop');
    if (cutoffTop) {
      var cutoffMessage = getShippingCutoffMessage(config);
      cutoffTop.innerHTML = cutoffMessage.html;
    }
    if (root) {
      root.dataset.shippingState = shipping.unlocked ? 'unlocked' : 'in-progress';
      root.dataset.shippingRemaining = String(shipping.remaining);
    }

    shippingBlock.hidden = false;
    if (topDivider) topDivider.hidden = false;
  }

  var cartRenderSeq = 0;

  function normalizeCartPayload(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var itemCount = cart && cart.item_count;
    if (!itemCount) {
      itemCount = items.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    }
    return {
      item_count: itemCount,
      items: items,
      items_subtotal_price: cart && (cart.items_subtotal_price || cart.total_price) || items.reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0),
      total_price: cart && (cart.total_price || cart.items_subtotal_price) || items.reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0)
    };
  }

  function paintCartBody(cart, items, renderId) {
    if (renderId !== cartRenderSeq) return;

    var body = document.getElementById('giftCartBody');
    var foot = document.getElementById('giftCartFoot');
    if (!body || !foot) return;

    var html = '<ul class="gift-cart__items">';
    items.forEach(function (item, index) {
      html += buildCartItemHtml(item, index);
    });
    html += '</ul>';
    html += buildGiftPromoHtml();
    html += buildUpsellHtml(cart);
    body.innerHTML = html;

    if (GIFT_CART_PROMO_FEATURES.giftPicker) initGiftPicker();
    updateCartUrgency(cart);
    updateGiftPromo(cart);
    foot.hidden = false;
    var totalCents = cart.total_price || cart.items_subtotal_price || 0;
    updateCartSubtotal(totalCents);
    updateCartCheckoutState(totalCents);
  }

  function renderCart(cart) {
    var body = document.getElementById('giftCartBody');
    var foot = document.getElementById('giftCartFoot');
    var count = document.getElementById('giftCartCount');
    if (!body || !foot) return Promise.resolve();

    var normalized = normalizeCartPayload(cart || {});
    cart = normalized;
    var renderId = ++cartRenderSeq;

    if (count) {
      count.textContent = cart.item_count;
      count.dataset.count = String(cart.item_count);
    }

    updateCartItemCount(cart.item_count);

    if (!cart.item_count) {
      body.innerHTML = buildEmptyCartHtml();
      initEmptyCartCarousel();
      foot.hidden = true;
      var shippingBlock = document.getElementById('giftCartShippingBlock');
      var topDivider = document.getElementById('giftCartTopDivider');
      var giftPromo = document.getElementById('giftCartGiftPromo');
      if (shippingBlock) shippingBlock.hidden = true;
      if (topDivider) topDivider.hidden = false;
      if (giftPromo) giftPromo.hidden = true;
      updateCartSubtotal(0);
      resetCartTerms();
      if (!demoCartPayload().item_count) setCartMode('');
      return Promise.resolve();
    }

    return enrichCartItems(cart.items)
      .then(function (items) {
        paintCartBody(cart, items, renderId);
      })
      .catch(function () {
        paintCartBody(cart, cart.items, renderId);
      });
  }

  function refreshCart() {
    if (isDemoCartActive()) {
      return Promise.resolve(renderCart(demoCartPayload()));
    }

    var demo = demoCartPayload();
    if (demo.item_count > 0) {
      setCartMode('demo');
      return Promise.resolve(renderCart(demo));
    }

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          setCartMode('shopify');
          return renderCart(cart);
        }
        setCartMode('');
        return renderCart(cart);
      })
      .catch(function () {
        var demo = demoCartPayload();
        if (demo.item_count > 0) {
          setCartMode('demo');
          return renderCart(demo);
        }
      });
  }

  function syncMiniCartViewport() {
    var cart = document.getElementById('giftMiniCart');
    if (!cart) return;
    var viewport = window.visualViewport;
    var height = Math.round((viewport && viewport.height) || window.innerHeight || 0);
    if (!height || height < 200) return;
    var current = parseInt(cart.style.height, 10) || 0;
    if (current && height < current * 0.6) return;
    var offsetTop = Math.round((viewport && viewport.offsetTop) || 0);
    cart.style.setProperty('--gift-cart-vh', height + 'px');
    cart.style.top = offsetTop + 'px';
    cart.style.height = height + 'px';
  }

  function bindMiniCartViewport() {
    if (window.__giftCartViewportBound) return;
    window.__giftCartViewportBound = true;
    syncMiniCartViewport();
    window.addEventListener('resize', syncMiniCartViewport);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncMiniCartViewport);
    }
  }

  function openCart(options) {
    options = options || {};
    var cart = document.getElementById('giftMiniCart');
    if (!cart) return;
    var alreadyOpen = cart.getAttribute('aria-hidden') === 'false';
    cart.setAttribute('aria-hidden', 'false');
    bindMiniCartViewport();
    syncMiniCartViewport();
    if (window.closeNav) window.closeNav();
    if (!alreadyOpen) bodyScrollLock.lock();

    var notice = document.getElementById('giftCartNotice');
    if (notice) notice.hidden = !options.justAdded;
    cart.classList.toggle('gift-cart--just-added', !!options.justAdded);
    if (options.justAdded) {
      window.setTimeout(function () {
        cart.classList.remove('gift-cart--just-added');
        if (notice) notice.hidden = true;
      }, 2400);
    }

    var closeBtn = document.getElementById('giftCartClose');
    if (closeBtn) window.setTimeout(function () { closeBtn.focus(); }, 320);

    if (!options.skipRefresh) refreshCart();
  }

  function closeCart() {
    var cart = document.getElementById('giftMiniCart');
    if (!cart) return;
    cart.setAttribute('aria-hidden', 'true');
    cart.classList.remove('gift-cart--just-added');
    var notice = document.getElementById('giftCartNotice');
    if (notice) notice.hidden = true;
    resetCartTerms();
    var nav = document.getElementById('giftNav');
    if (!nav || nav.getAttribute('aria-hidden') !== 'false') bodyScrollLock.unlock();
  }

  window.openCart = openCart;

  function initCartItemControls() {
    var body = document.getElementById('giftCartBody');
    if (!body || body.dataset.cartControlsBound === 'true') return;
    body.dataset.cartControlsBound = 'true';

    body.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-cart-remove]');
      var decBtn = event.target.closest('[data-cart-dec]');
      var incBtn = event.target.closest('[data-cart-inc]');
      var upsellBtn = event.target.closest('[data-upsell-handle]');
      var exploreLink = event.target.closest('[data-cart-explore]');
      var emptyPrev = event.target.closest('[data-empty-carousel-prev]');
      var emptyNext = event.target.closest('[data-empty-carousel-next]');

      if (emptyPrev) {
        setEmptyCartCarousel(emptyCartCarouselIndex - 1);
        return;
      }

      if (emptyNext) {
        setEmptyCartCarousel(emptyCartCarouselIndex + 1);
        return;
      }

      if (exploreLink) {
        closeCart();
        return;
      }

      if (removeBtn) {
        updateCartLine(removeBtn.getAttribute('data-line-key'), 0);
        return;
      }

      if (decBtn) {
        var decQty = parseInt(decBtn.getAttribute('data-qty') || '1', 10);
        updateCartLine(decBtn.getAttribute('data-line-key'), Math.max(0, decQty - 1));
        return;
      }

      if (incBtn) {
        var incQty = parseInt(incBtn.getAttribute('data-qty') || '1', 10);
        updateCartLine(incBtn.getAttribute('data-line-key'), incQty + 1);
        return;
      }

      if (upsellBtn) {
        addUpsellByHandle(upsellBtn.getAttribute('data-upsell-handle'));
      }
    });
  }

  function initMiniCart() {
    var cart = document.getElementById('giftMiniCart');
    var openBtn = document.getElementById('giftCartOpen');
    var closeBtn = document.getElementById('giftCartClose');
    var backdrop = document.getElementById('giftCartBackdrop');
    var panel = cart ? cart.querySelector('.gift-cart__panel') : null;
    var termsCheckbox = document.getElementById('giftCartTerms');
    var checkoutBtn = document.getElementById('giftCartCheckout');
    bindMiniCartViewport();

    function handleOverlayClose(event) {
      if (!isCartOpen()) return;
      if (panel && panel.contains(event.target)) return;
      closeCart();
    }

    if (openBtn) openBtn.addEventListener('click', openCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (backdrop) backdrop.addEventListener('click', handleOverlayClose);
    if (cart) cart.addEventListener('click', handleOverlayClose);
    if (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    if (termsCheckbox) {
      termsCheckbox.addEventListener('change', function () {
        var checkoutPrice = document.getElementById('giftCartCheckoutPrice');
        var cents = checkoutPrice ? parsePriceCents(checkoutPrice.textContent) : 0;
        updateCartCheckoutState(cents);
      });
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        var terms = document.getElementById('giftCartTerms');
        if (!terms || !terms.checked) {
          e.preventDefault();
          var error = document.getElementById('giftCartTermsError');
          if (error) error.hidden = false;
          if (terms) terms.focus();
          return;
        }

        if (checkoutBtn.getAttribute('aria-busy') === 'true') {
          e.preventDefault();
          return;
        }

        e.preventDefault();
        checkoutBtn.setAttribute('aria-busy', 'true');

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            attributes: {
              terms_accepted: 'yes',
              terms_accepted_at: new Date().toISOString()
            }
          })
        })
          .catch(function () {})
          .finally(function () {
            window.location.href = checkoutBtn.href;
          });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isCartOpen()) closeCart();
    });

    initCartItemControls();
    initGiftPicker();
    updateCartCheckoutState(0);
    refreshCart();
  }

  function isGiftAddForm(form) {
    return !!(form && (
      form.id === 'giftPdpForm' ||
      form.classList.contains('gift-pdp__form') ||
      form.classList.contains('gift-pdp__upsell-form') ||
      form.classList.contains('gift-shop-card__form') ||
      form.hasAttribute('data-quick-add-form') ||
      form.hasAttribute('data-demo-product')
    ));
  }

  function initAjaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM' || !isGiftAddForm(form)) return;
      e.preventDefault();
      e.stopPropagation();

      var submitBtn = e.submitter || form.querySelector('button[type="submit"]');
      var idInput = form.querySelector('[name="id"]');
      var isDemo = form.hasAttribute('data-demo-product') || isDemoVariantId(idInput && idInput.value);

      if (isDemo) {
        handleDemoAddToCart(form, submitBtn);
        return;
      }

      setAddLoading(submitBtn, true);

      function finishAdd() {
        setAddLoading(submitBtn, false);
      }

      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (form.hasAttribute('data-quick-add-form')) {
            closeCardQuickAdd(form.closest('[data-plp-card]'));
          }
          return refreshCart();
        })
        .then(function () {
          openCart({ justAdded: true, skipRefresh: true });
        })
        .catch(function () {
          handleDemoAddToCart(form, submitBtn);
        })
        .finally(finishAdd);
    });
  }

  function initCarousel(root) {
    var scope = root || document;
    scope.querySelectorAll('.gift-carousel-wrap:not([data-carousel-ready])').forEach(function (wrap) {
      var carousel = wrap.querySelector('[data-carousel]');
      if (!carousel) return;
      var host = wrap.closest('.gift-pdp-handpicked') || wrap;
      var prev = wrap.querySelector('[data-carousel-prev]') || host.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]') || host.querySelector('[data-carousel-next]');
      var amount = Math.max(280, carousel.clientWidth * 0.85);
      if (prev) prev.addEventListener('click', function () { carousel.scrollBy({ left: -amount, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { carousel.scrollBy({ left: amount, behavior: 'smooth' }); });
      wrap.setAttribute('data-carousel-ready', '1');
    });
  }

  function getCardData(card) {
    var dataEl = card.querySelector('.gift-plp-card-data');
    if (!dataEl) return null;
    try {
      var raw = (dataEl.textContent || '').trim();
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function buildFallbackCardData(card) {
    var titleEl = card.querySelector('.gift-shop-card__title a, .gift-shop-card__title');
    var priceEl = card.querySelector('.gift-shop-card__price-sale, .gift-shop-card__price > span, .gift-shop-card__price');
    var imageEl = card.querySelector('.gift-shop-card__img');
    var linkEl = card.querySelector('.gift-shop-card__title a');
    return {
      handle: card.getAttribute('data-card-uid') || '',
      title: titleEl ? titleEl.textContent.trim() : '',
      url: linkEl ? linkEl.href : '',
      image: imageEl ? imageEl.src : '',
      is_demo: card.hasAttribute('data-demo-product-card'),
      options: [
        { name: 'Color', position: 0, values: ['Cool Ash Blonde', 'Dark Brown'] },
        { name: 'Density', position: 1, values: ['2 Bundles', '3 Bundles'] },
        { name: 'Size', position: 2, values: ['Small', 'Medium'] },
        { name: 'Length', position: 3, values: ['18"', '20"'] }
      ],
      swatches: [
        { value: 'Cool Ash Blonde', image: imageEl ? imageEl.src : '', option_index: 0 },
        { value: 'Dark Brown', image: imageEl ? imageEl.src : '', option_index: 0 }
      ],
      variants: (function () {
        var base = parsePriceCents(priceEl ? priceEl.textContent : '') || 0;
        var colors = [['Cool Ash Blonde', 'cab'], ['Dark Brown', 'db']];
        var densities = [['2 Bundles', '2b', 0], ['3 Bundles', '3b', 10000]];
        var sizes = [['Small', 's', 0], ['Medium', 'm', 5000]];
        var lengths = [['18"', '18', 0], ['20"', '20', 2000]];
        var out = [];
        colors.forEach(function (color) {
          densities.forEach(function (density) {
            sizes.forEach(function (size) {
              lengths.forEach(function (length) {
                var price = base + density[2] + size[2] + length[2] + (color[1] === 'db' ? -5000 : 0);
                out.push({
                  id: 'demo-variant-' + color[1] + '-' + density[1] + '-' + size[1] + '-' + length[1],
                  title: color[0] + ' / ' + density[0] + ' / ' + size[0] + ' / ' + length[0],
                  price: price,
                  compare_at_price: null,
                  available: true,
                  options: [color[0], density[0], size[0], length[0]]
                });
              });
            });
          });
        });
        return out;
      })()
    };
  }

  function getCardPreviewColor(card) {
    return card ? card.getAttribute('data-preview-color') || '' : '';
  }

  function initShopCardPreviews() {
    document.querySelectorAll('[data-plp-card]').forEach(function (card) {
      var active = card.querySelector('[data-plp-preview-swatch].is-active');
      if (active) {
      card.setAttribute('data-preview-color', active.getAttribute('data-preview-value') || 'Red');
      }
    });

    document.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-plp-preview-swatch]');
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();

      var card = swatch.closest('[data-plp-card]');
      if (!card) return;

      var previewImage = swatch.getAttribute('data-preview-image');
      var previewHoverImage = swatch.getAttribute('data-preview-hover-image');
      var previewValue = swatch.getAttribute('data-preview-value');
      var primaryImg = card.querySelector('[data-plp-primary-image]');
      var hoverImg = card.querySelector('[data-plp-hover-image]');
      var cardImg = card.querySelector('.gift-shop-card__img:not([data-plp-hover-image])');

      if (primaryImg && previewImage) primaryImg.src = previewImage;
      else if (cardImg && previewImage) cardImg.src = previewImage;
      if (hoverImg && previewHoverImage) hoverImg.src = previewHoverImage;
      if (previewValue) card.setAttribute('data-preview-color', previewValue);

      card.querySelectorAll('[data-plp-preview-swatch]').forEach(function (btn) {
        var active = btn === swatch;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  function closeCardQuickAdd(card) {
    if (!card) return;
    var panel = card.querySelector('[data-card-quick-add]');
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'true');
    card.classList.remove('is-quick-add-open');
  }

  function closeAllCardQuickAdds(exceptCard) {
    document.querySelectorAll('[data-plp-card].is-quick-add-open').forEach(function (card) {
      if (card !== exceptCard) closeCardQuickAdd(card);
    });
  }

  function initQuickAddDrawer() {
    var legacyDrawer = document.getElementById('giftQuickAdd');
    if (legacyDrawer) legacyDrawer.remove();

    function optionKind(name) {
      var down = String(name || '').toLowerCase();
      if (down.indexOf('color') !== -1 || down.indexOf('colour') !== -1) return 'color';
      if (down.indexOf('density') !== -1) return 'density';
      if (down.indexOf('size') !== -1) return 'size';
      if (down.indexOf('length') !== -1) return 'length';
      return 'other';
    }

    function optionPriority(name) {
      var priorities = { color: 0, length: 1, density: 2, size: 3, other: 4 };
      return priorities[optionKind(name)] != null ? priorities[optionKind(name)] : 4;
    }

    function getPanelElements(card) {
      var panel = card.querySelector('[data-card-quick-add]');
      if (!panel) return null;
      return {
        panel: panel,
        form: panel.querySelector('[data-quick-add-form]'),
        optionsEl: panel.querySelector('[data-quick-add-options]'),
        imageEl: panel.querySelector('[data-quick-add-image]'),
        titleEl: panel.querySelector('[data-quick-add-title]'),
        priceEl: panel.querySelector('[data-quick-add-price]'),
        pdpLink: panel.querySelector('[data-quick-add-pdp-link]'),
        variantInput: panel.querySelector('[data-quick-add-variant-id]'),
        submitBtn: panel.querySelector('[data-quick-add-submit]'),
        submitLabel: panel.querySelector('[data-quick-add-submit-label]')
      };
    }

    function selectedDrawerOptions(optionsEl) {
      var opts = [];
      if (!optionsEl) return opts;
      optionsEl.querySelectorAll('[data-quick-add-option]:checked').forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-index') || '0', 10);
        opts[index] = input.value;
      });
      return opts;
    }

    function formatSubmitLabel(title, priceCents, unavailable) {
      if (unavailable) return 'Sold out';
      var label = 'Buy ' + (title || 'product');
      if (priceCents) label += ' - ' + money(priceCents);
      return label;
    }

    function updateQuickAddVariant(card, data, elements) {
      if (!data || !elements || !elements.variantInput) return;

      var opts = selectedDrawerOptions(elements.optionsEl);
      var match = (data.variants || []).find(function (variant) {
        if (!variant.options || !variant.options.length) return false;
        return variant.options.every(function (value, index) {
          if (opts[index] == null || opts[index] === '') return true;
          return value === opts[index];
        });
      }) || (data.variants || []).find(function (variant) { return variant.available !== false; }) || (data.variants || [])[0];

      if (!match) return;

      elements.variantInput.value = match.id;

      if (elements.priceEl) {
        elements.priceEl.setAttribute('data-price-text', money(match.price));
        elements.priceEl.textContent = money(match.price);
      }

      if (elements.submitBtn) {
        var unavailable = match.available === false;
        elements.submitBtn.disabled = unavailable;
        if (elements.submitLabel) {
          elements.submitLabel.textContent = formatSubmitLabel(data.title, match.price, unavailable);
        }
      }

      if (elements.optionsEl) {
        elements.optionsEl.querySelectorAll('[data-quick-add-option]').forEach(function (input) {
          var index = input.getAttribute('data-option-index');
          var label = elements.optionsEl.querySelector('[data-quick-add-label="' + index + '"]');
          if (label && input.checked) label.textContent = input.value;
        });
      }
    }

    function buildDrawerOptions(card, data, previewColor, elements) {
      if (!elements || !elements.optionsEl) return;
      var cardUid = card.getAttribute('data-card-uid') || 'card';
      var html = '';
      var options = (data.options || []).slice().sort(function (a, b) {
        return optionPriority(a.name) - optionPriority(b.name);
      });

      options.forEach(function (option) {
        var values = option.values || [];
        if (!values.length) return;
        var kind = optionKind(option.name);
        if (kind === 'other') return;
        var selectedValue = values[0];
        if (kind === 'color' && previewColor && values.indexOf(previewColor) !== -1) {
          selectedValue = previewColor;
        }

        html += '<fieldset class="gift-card-quick-add__option gift-card-quick-add__option--' + kind + '">';
        html += '<p class="gift-card-quick-add__option-label">' + escapeHtml(option.name) + ': <strong data-quick-add-label="' + option.position + '">' + escapeHtml(selectedValue) + '</strong></p>';

        if (kind === 'color') {
          html += '<div class="gift-card-quick-add__swatch-row" role="group" aria-label="' + escapeAttr(option.name) + '">';
          values.forEach(function (value) {
            html += '<label class="gift-card-quick-add__swatch" title="' + escapeAttr(value) + '">';
            html += '<input type="radio" name="qa-' + escapeAttr(cardUid) + '-' + option.position + '" value="' + escapeAttr(value) + '" data-quick-add-option data-option-index="' + option.position + '"' + (value === selectedValue ? ' checked' : '') + '>';
            html += '<span class="gift-card-quick-add__swatch-face">' + colorSwatchHtml(value) + '</span></label>';
          });
          html += '</div>';
        } else {
          html += '<div class="gift-card-quick-add__pill-row" role="group" aria-label="' + escapeAttr(option.name) + '">';
          values.forEach(function (value) {
            html += '<label class="gift-card-quick-add__pill" title="' + escapeAttr(value) + '">';
            html += '<input type="radio" name="qa-' + escapeAttr(cardUid) + '-' + option.position + '" value="' + escapeAttr(value) + '" data-quick-add-option data-option-index="' + option.position + '"' + (value === selectedValue ? ' checked' : '') + '>';
            html += '<span>' + escapeHtml(value) + '</span></label>';
          });
          html += '</div>';
        }

        html += '</fieldset>';
      });

      elements.optionsEl.innerHTML = html;
      updateQuickAddVariant(card, data, elements);
    }

    function openQuickAdd(card) {
      var elements = getPanelElements(card);
      if (!elements) {
        var fallbackLink = card.querySelector('.gift-shop-card__title a');
        if (fallbackLink) window.location.href = fallbackLink.href;
        return;
      }

      var data = getCardData(card) || buildFallbackCardData(card);
      if (!data) return;

      closeAllCardQuickAdds(card);

      if (elements.titleEl) elements.titleEl.textContent = data.title || '';
      if (elements.pdpLink) {
        elements.pdpLink.href = data.url || '#';
        elements.pdpLink.hidden = !data.url;
      }

      var previewColor = getCardPreviewColor(card);
      var previewSwatch = (data.swatches || []).find(function (entry) { return entry.value === previewColor; });
      var heroImage = previewSwatch && previewSwatch.image ? previewSwatch.image : data.image;
      if (elements.imageEl) {
        elements.imageEl.src = heroImage || '';
        elements.imageEl.alt = data.title || '';
      }

      if (elements.form) {
        if (data.is_demo) elements.form.setAttribute('data-demo-product', '');
        else elements.form.removeAttribute('data-demo-product');
        elements.form.dataset.demoUrl = data.url || '';
      }

      buildDrawerOptions(card, data, previewColor, elements);
      elements.panel.setAttribute('aria-hidden', 'false');
      card.classList.add('is-quick-add-open');
      var closeBtn = elements.panel.querySelector('[data-quick-add-close]');
      if (closeBtn) closeBtn.focus();
    }

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-quick-add-open]');
      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();
        var card = openBtn.closest('[data-plp-card]');
        if (!card) return;
        var panel = card.querySelector('[data-card-quick-add]');
        if (panel && panel.getAttribute('aria-hidden') === 'false') {
          closeCardQuickAdd(card);
          return;
        }
        openQuickAdd(card);
        return;
      }

      if (event.target.closest('[data-quick-add-close]')) {
        event.preventDefault();
        var closeCard = event.target.closest('[data-plp-card]');
        closeCardQuickAdd(closeCard);
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-quick-add-option]')) return;
      var card = event.target.closest('[data-plp-card]');
      if (!card) return;
      var data = getCardData(card) || buildFallbackCardData(card);
      updateQuickAddVariant(card, data, getPanelElements(card));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openCard = document.querySelector('[data-plp-card].is-quick-add-open');
      if (openCard) closeCardQuickAdd(openCard);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.hasAttribute('data-quick-add-form')) return;
      var card = form.closest('[data-plp-card]');
      var data = card ? (getCardData(card) || buildFallbackCardData(card)) : null;
      if (data && data.is_demo) {
        form.dataset.demoUrl = data.url || '';
      }
    });
  }

  function restorePdpScroll(scrollY) {
    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
      window.requestAnimationFrame(function () {
        window.scrollTo(0, scrollY);
      });
    });
    window.setTimeout(function () {
      window.scrollTo(0, scrollY);
    }, 0);
  }

  function initPdpScrollGuard() {
    var section = document.getElementById('giftPdp');
    if (!section || section.dataset.pdpScrollGuard === '1') return;
    section.dataset.pdpScrollGuard = '1';

    var savedScrollY = null;

    function isRightColumnTarget(target) {
      return target && target.closest && (target.closest('.gift-pdp__buy-col') || target.closest('.gift-pdp__details-col'));
    }

    section.addEventListener('pointerdown', function (event) {
      if (!isRightColumnTarget(event.target)) return;
      savedScrollY = window.scrollY;
    }, true);

    section.addEventListener('click', function (event) {
      if (savedScrollY === null || !isRightColumnTarget(event.target)) return;
      var scrollY = savedScrollY;
      savedScrollY = null;
      restorePdpScroll(scrollY);
    }, true);

    section.addEventListener('change', function (event) {
      if (!isRightColumnTarget(event.target)) return;
      if (savedScrollY !== null) restorePdpScroll(savedScrollY);
    }, true);

    section.querySelectorAll('.gift-pdp__buy-col button, .gift-pdp__details-col button, .gift-pdp__buy-col label, .gift-pdp__details-col label').forEach(function (el) {
      el.addEventListener('mousedown', function () {
        var scrollY = window.scrollY;
        restorePdpScroll(scrollY);
      });
    });
  }

  function initPdp() {
    var form = document.getElementById('giftPdpForm');
    var dataEl = document.getElementById('giftPdpVariants');
    if (!form || !dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    // Money strings rendered by Liquid, keyed by variant id (see the section).
    // Present on a real product page; absent on the demo PDP, which falls back
    // to the JS formatter.
    var priceStrings = {};
    var priceDataEl = document.getElementById('giftPdpVariantPrices');
    if (priceDataEl) {
      try { priceStrings = JSON.parse(priceDataEl.textContent) || {}; } catch (e) { priceStrings = {}; }
    }
    function variantMoney(variant, field, cents) {
      var row = priceStrings[variant.id];
      if (row && typeof row[field] === 'string' && row[field]) return row[field];
      return money(cents);
    }
    // Variant descriptions rendered by Liquid (see the section). Only present
    // when at least one variant has custom.variant_description.
    var descriptions = null;
    var descriptionDataEl = document.getElementById('giftPdpVariantDescriptions');
    if (descriptionDataEl) {
      try { descriptions = JSON.parse(descriptionDataEl.textContent); } catch (e) { descriptions = null; }
    }
    var descriptionEl = document.querySelector('[data-pdp-description]');
    // Set by the Read More block below so a swapped description re-measures.
    var onDescriptionChange = function () {};
    var idInput = document.getElementById('giftPdpVariantId');
    var priceEl = document.getElementById('giftPdpPrice');
    var stickyPriceEl = document.getElementById('giftPdpStickyPrice');
    var selectedLabelEl = document.getElementById('giftPdpSelectedLabel');
    var mediaEls = Array.prototype.slice.call(document.querySelectorAll('.gift-pdp__media'));
    var thumbEls = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
    var useColorGallery = !!document.querySelector('[data-pdp-stage-media]');

    // Keyed by the option's REAL position in the product (the index each input
    // carries), never by the order the fieldsets happen to appear in.
    // gift-pdp-options.liquid deliberately renders Color/Length/Density/Size
    // first, so on a product whose options are Length/Bundles/Size the DOM order
    // is 0,2,1: reading positionally paired "Medium" with "3 Bundles 200%",
    // matched no variant, and left the price sitting on the first variant.
    // Same shape as selectedDrawerOptions() in the quick-add drawer, which has
    // always done it this way.
    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        if (!input.checked) return;
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        if (isNaN(index)) return;
        opts[index] = input.value;
      });
      return opts;
    }

    function pauseGalleryVideos() {
      document.querySelectorAll('.gift-pdp__media video').forEach(function (video) {
        video.pause();
      });
    }

    function setActiveMedia(index) {
      if (!mediaEls.length) return;
      pauseGalleryVideos();
      var i = ((index % mediaEls.length) + mediaEls.length) % mediaEls.length;
      var id = mediaEls[i].getAttribute('data-media-id');
      mediaEls.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
      });
      thumbEls.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-thumb') === id);
      });
    }

    function findVariant(opts) {
      // No option radios means the default variant (Title / Default Title).
      // There is nothing to select, so keep the variant the server already chose.
      if (!optionInputs().length) {
        var currentId = idInput ? String(idInput.value) : '';
        return variants.find(function (v) { return String(v.id) === currentId; }) || variants[0];
      }
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function optionInputs() {
      return Array.prototype.slice.call(form.querySelectorAll('[data-option-input]'));
    }

    function syncSelectedLabel(input) {
      var index = input.getAttribute('data-option-index');
      var label = document.querySelector('[data-selected-label="' + index + '"]');
      if (!label) return;
      var displayValue = input.value;
      var pdpSection = document.getElementById('giftPdp');
      if (pdpSection && pdpSection.classList.contains('gift-pdp--fenty') && index !== '1') {
        displayValue = displayValue.toUpperCase();
      }
      label.textContent = displayValue;
    }

    // Not every combination of option values is a real variant (the wigs do not
    // come in 16" with 4 bundles or 24" with 2 bundles). When the picked
    // combination has no variant, keep the value the shopper just chose and
    // move the other options to the closest variant that has it, so the price
    // and the hidden variant id never drift away from what the pills show.
    function snapToAvailable(changedIndex) {
      var opts = selectedOptions();
      if (findVariant(opts)) return;
      var candidates = isNaN(changedIndex)
        ? variants.slice()
        : variants.filter(function (v) { return v.options[changedIndex] === opts[changedIndex]; });
      if (!candidates.length) candidates = variants.slice();
      var best = null;
      candidates.forEach(function (v) {
        var score = v.options.filter(function (o, i) { return o === opts[i]; }).length;
        if (!best || score > best.score) best = { variant: v, score: score };
      });
      if (!best) return;
      optionInputs().forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        if (isNaN(i)) return;
        var shouldCheck = input.value === best.variant.options[i];
        if (shouldCheck && !input.checked) {
          input.checked = true;
          syncSelectedLabel(input);
        }
      });
    }

    // Grey out every pill that, combined with the other current picks, has no
    // variant behind it. The pill stays clickable: choosing it snaps the rest.
    function syncAvailability() {
      var opts = selectedOptions();
      optionInputs().forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        if (isNaN(i)) return;
        var test = opts.slice();
        test[i] = input.value;
        var ok = !!findVariant(test);
        var holder = input.closest('label');
        if (!holder) return;
        holder.classList.toggle('is-unavailable', !ok);
        if (ok) holder.removeAttribute('title');
        else holder.setAttribute('title', 'Not offered with the current selection; picking it adjusts the other options');
      });
    }

    function setAddEnabled(enabled) {
      var buttons = [form.querySelector('button.gift-pdp__add[type="submit"]'), document.querySelector('[data-sticky-atc]')];
      buttons.forEach(function (btn) {
        if (!btn) return;
        if (!enabled) {
          if (!btn.disabled) btn.dataset.pdpLockedByPicker = '1';
          btn.disabled = true;
        } else if (btn.dataset.pdpLockedByPicker === '1') {
          delete btn.dataset.pdpLockedByPicker;
          btn.disabled = false;
        }
        var labelEl = btn.querySelector('.gift-btn__label') || btn;
        if (!enabled) {
          if (!btn.dataset.pdpLabelBackup) btn.dataset.pdpLabelBackup = labelEl.textContent;
          labelEl.textContent = 'Unavailable';
        } else if (btn.dataset.pdpLabelBackup) {
          labelEl.textContent = btn.dataset.pdpLabelBackup;
          delete btn.dataset.pdpLabelBackup;
        }
      });
    }

    function updateVariant() {
      var opts = selectedOptions();
      var match = findVariant(opts);
      syncAvailability();
      if (!match) {
        setAddEnabled(false);
        return;
      }
      setAddEnabled(true);
      if (idInput) idInput.value = match.id;
      var priceText = variantMoney(match, 'price', match.price);
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      var priceHtml = onSale
        ? '<span class="gift-pdp__price-sale">' + priceText + '</span><span class="gift-pdp__price-compare"><s>' +
          variantMoney(match, 'compare_at_price', match.compare_at_price) + '</s></span>'
        : '<span>' + priceText + '</span>';
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPriceEl) stickyPriceEl.textContent = priceText;
      if (selectedLabelEl) selectedLabelEl.textContent = match.title;
      var installmentFooter = document.querySelector('[data-pdp-installment-footer]');
      var paymentText = variantMoney(match, 'installment', Math.round(match.price / 4));
      if (installmentFooter) installmentFooter.textContent = 'or 4 interest-free payments of ' + paymentText;
      var addPriceEl = document.querySelector('[data-pdp-add-price]');
      if (addPriceEl) addPriceEl.textContent = priceText;
      if (descriptions && descriptionEl) {
        var descriptionHtml = descriptions[match.id] || descriptions['default'] || '';
        if (descriptionEl.innerHTML !== descriptionHtml) {
          descriptionEl.innerHTML = descriptionHtml;
          onDescriptionChange();
        }
      }
    }

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncSelectedLabel(input);
        snapToAvailable(parseInt(input.getAttribute('data-option-index'), 10));
        updateVariant();
      });
    });

    // The server renders the first available variant, but a shopper can land
    // with stale radio state (back button, autofill); settle on a real variant.
    snapToAvailable(NaN);
    updateVariant();

    if (!useColorGallery) {
      thumbEls.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          setActiveMedia(index);
        });
      });

      var prevBtn = document.querySelector('[data-gallery-prev]');
      var nextBtn = document.querySelector('[data-gallery-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var current = mediaEls.findIndex(function (el) { return el.classList.contains('is-active'); });
          setActiveMedia(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var current = mediaEls.findIndex(function (el) { return el.classList.contains('is-active'); });
          setActiveMedia(current + 1);
        });
      }

      var stage = document.querySelector('.gift-pdp__stage');
      if (stage && mediaEls.length > 1) {
        var touchStartX = 0;
        var touchStartY = 0;

        stage.addEventListener('touchstart', function (e) {
          if (!e.changedTouches.length) return;
          touchStartX = e.changedTouches[0].clientX;
          touchStartY = e.changedTouches[0].clientY;
        }, { passive: true });

        stage.addEventListener('touchend', function (e) {
          if (!e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var current = mediaEls.findIndex(function (el) { return el.classList.contains('is-active'); });
          setActiveMedia(current + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    }

    var readMoreBtn = document.querySelector('[data-read-more]');
    if (readMoreBtn) {
      var excerptWrap = document.querySelector('[data-pdp-excerpt]');
      var shortEl = excerptWrap && excerptWrap.querySelector('.gift-pdp__excerpt-short');
      var fullEl = excerptWrap && excerptWrap.querySelector('.gift-pdp__excerpt-full');
      var labelEl = readMoreBtn.querySelector('[data-read-more-label]');

      // The description is clamped to three lines in CSS. Offer the toggle only
      // when the copy is actually longer than that, otherwise a two line
      // description would carry a Read More that opens nothing.
      var syncReadMoreVisibility = function () {
        if (!shortEl || fullEl) return;
        if (excerptWrap.classList.contains('is-expanded')) return;
        var overflows = shortEl.scrollHeight - shortEl.clientHeight > 1;
        readMoreBtn.hidden = !overflows;
      };
      syncReadMoreVisibility();
      onDescriptionChange = syncReadMoreVisibility;
      window.addEventListener('resize', syncReadMoreVisibility);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncReadMoreVisibility);
      }

      readMoreBtn.addEventListener('click', function () {
        var expanded = readMoreBtn.getAttribute('aria-expanded') === 'true';
        readMoreBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (excerptWrap) excerptWrap.classList.toggle('is-expanded', !expanded);
        // Older markup shipped a separate full copy of the description. Keep it
        // working, but leave the single clamped block alone when it is absent.
        if (fullEl) {
          if (shortEl) shortEl.hidden = !expanded;
          fullEl.hidden = expanded;
        }
        if (labelEl) labelEl.textContent = expanded ? 'Read More' : 'Read Less';
      });
    }

    document.querySelectorAll('[data-pdp-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var scrollY = window.scrollY;
        var item = trigger.closest('.gift-pdp__accordion');
        var panel = item && item.querySelector('.gift-pdp__accordion-panel');
        if (!item || !panel) return;
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
        window.requestAnimationFrame(function () {
          window.scrollTo(0, scrollY);
        });
      });
    });

    document.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tab-btn');
        document.querySelectorAll('[data-tab-btn]').forEach(function (other) {
          var active = other === btn;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          var active = panel.getAttribute('data-tab-panel') === id;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });

    var detailsLink = document.querySelector('[data-scroll-details]');
    var detailsTarget = document.getElementById('giftPdpDetails');
    if (detailsLink && detailsTarget) {
      detailsLink.addEventListener('click', function () {
        detailsTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var stickyBar = document.querySelector('[data-pdp-sticky]');
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    var buyBox = document.querySelector('.gift-pdp__buy-box');
    if (stickyBar && buyBox) {
      stickyBar.removeAttribute('hidden');
      var stickyMql = window.matchMedia('(max-width: 960px)');

      function syncStickyBar() {
        if (!stickyMql.matches) {
          stickyBar.classList.remove('is-visible');
          return;
        }
        var rect = buyBox.getBoundingClientRect();
        stickyBar.classList.toggle('is-visible', rect.bottom < 0);
      }

      window.addEventListener('scroll', syncStickyBar, { passive: true });
      stickyMql.addEventListener('change', syncStickyBar);
      syncStickyBar();
    }

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        if (stickyAtc.disabled) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    var addBtn = form.querySelector('[data-pdp-add-btn], button.gift-pdp__add[type="submit"]');
    if (addBtn && form.dataset.pdpAddBound !== '1') {
      form.dataset.pdpAddBound = '1';
      addBtn.addEventListener('click', function (e) {
        var idInput = document.getElementById('giftPdpVariantId');
        var isDemo = form.hasAttribute('data-demo-product') || isDemoVariantId(idInput && idInput.value);
        if (!isDemo) return;
        e.preventDefault();
        handleDemoAddToCart(form, addBtn);
      });
    }

    var qtyWrap = form.querySelector('[data-pdp-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('.gift-pdp__qty-input');
      var decBtn = qtyWrap.querySelector('[data-pdp-qty-dec]');
      var incBtn = qtyWrap.querySelector('[data-pdp-qty-inc]');

      function syncQty(next) {
        if (!qtyInput) return;
        var value = Math.max(1, parseInt(String(next), 10) || 1);
        qtyInput.value = String(value);
      }

      if (decBtn) {
        decBtn.addEventListener('click', function () {
          var scrollY = window.scrollY;
          syncQty((parseInt(qtyInput.value || '1', 10) || 1) - 1);
          restorePdpScroll(scrollY);
        });
      }

      if (incBtn) {
        incBtn.addEventListener('click', function () {
          var scrollY = window.scrollY;
          syncQty((parseInt(qtyInput.value || '1', 10) || 1) + 1);
          restorePdpScroll(scrollY);
        });
      }
    }

    initPdpScrollGuard();
  }

  function initPdpSizingModal() {
    var modal = document.querySelector('[data-pdp-sizing-modal]');
    if (!modal || modal.dataset.pdpSizingBound === '1') return;
    modal.dataset.pdpSizingBound = '1';

    // Every player in the popup: the built-in measuring clip, a section picked
    // video, or the product's own size guide media.
    var videos = modal.querySelectorAll('video');
    var openers = document.querySelectorAll('[data-pdp-sizing-open]');
    var closers = modal.querySelectorAll('[data-pdp-sizing-close]');

    // Wig size picker inside the popup. It mirrors the PDP's Size option both
    // ways: opening the popup shows the size already chosen, and picking a
    // size in the popup checks the matching PDP input, so price, variant and
    // Add to cart update exactly as if the shopper had clicked it there.
    var sizeGroup = modal.querySelector('[data-size-pick-group]');
    var sizeLabel = modal.querySelector('[data-size-pick-label]');

    function pdpSizeInputs() {
      if (!sizeGroup) return [];
      var name = 'options[' + sizeGroup.getAttribute('data-option-name') + ']';
      return Array.prototype.filter.call(document.querySelectorAll('#giftPdp [data-option-input]'), function (input) {
        return input.name === name;
      });
    }

    function syncSizeFromPdp() {
      if (!sizeGroup) return;
      var current = pdpSizeInputs().filter(function (input) { return input.checked; })[0];
      if (!current) return;
      sizeGroup.querySelectorAll('[data-size-pick]').forEach(function (pick) {
        pick.checked = pick.value === current.value;
      });
      if (sizeLabel) sizeLabel.textContent = current.value;
    }

    if (sizeGroup) {
      sizeGroup.addEventListener('change', function (event) {
        var pick = event.target.closest('[data-size-pick]');
        if (!pick) return;
        if (sizeLabel) sizeLabel.textContent = pick.value;
        pdpSizeInputs().forEach(function (input) {
          if (input.value === pick.value && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    function openModal() {
      syncSizeFromPdp();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gift-pdp-modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gift-pdp-modal-open');
      videos.forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initFooterAccordion() {
    var panels = document.querySelectorAll('.gift-footer__col');
    if (!panels.length) return;

    var mql = window.matchMedia('(max-width: 768px)');

    function syncPanels() {
      panels.forEach(function (panel) {
        var toggle = panel.querySelector('.gift-footer__col-toggle');
        var body = panel.querySelector('.gift-footer__col-body');
        if (!toggle || !body) return;

        if (mql.matches) {
          var open = panel.classList.contains('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) body.removeAttribute('hidden');
          else body.setAttribute('hidden', '');
        } else {
          panel.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          body.removeAttribute('hidden');
        }
      });
    }

    panels.forEach(function (panel) {
      var toggle = panel.querySelector('.gift-footer__col-toggle');
      var body = panel.querySelector('.gift-footer__col-body');
      if (!toggle || !body) return;

      toggle.addEventListener('click', function () {
        if (!mql.matches) return;
        var willOpen = !panel.classList.contains('is-open');
        panels.forEach(function (other) {
          other.classList.remove('is-open');
          var otherToggle = other.querySelector('.gift-footer__col-toggle');
          var otherBody = other.querySelector('.gift-footer__col-body');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          if (otherBody) otherBody.setAttribute('hidden', '');
        });
        if (willOpen) {
          panel.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          body.removeAttribute('hidden');
        }
      });
    });

    if (mql.addEventListener) mql.addEventListener('change', syncPanels);
    else if (mql.addListener) mql.addListener(syncPanels);
    syncPanels();
  }

  function initShoppableReel() {
    document.querySelectorAll('.gift-shoppable-reel').forEach(function (section) {
      var track = section.querySelector('[data-shoppable-track]');
      if (!track) return;

      var slides = track.querySelectorAll('[data-shoppable-slide]');
      var prev = section.querySelector('[data-shoppable-prev]');
      var next = section.querySelector('[data-shoppable-next]');
      if (!slides.length) return;

      var activeIndex = 0;
      var scrollRaf = null;

      function updateNav() {
        if (prev) prev.disabled = activeIndex <= 0;
        if (next) next.disabled = activeIndex >= slides.length - 1;
      }

      function updateActive() {
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width * 0.5;
        var closest = null;
        var closestDist = Infinity;
        var closestIndex = 0;

        slides.forEach(function (slide, index) {
          var rect = slide.getBoundingClientRect();
          var slideCenter = rect.left + rect.width * 0.5;
          var dist = Math.abs(slideCenter - centerX);
          slide.classList.remove('is-active');
          if (dist < closestDist) {
            closestDist = dist;
            closest = slide;
            closestIndex = index;
          }
        });

        if (closest) {
          activeIndex = closestIndex;
          closest.classList.add('is-active');
          slides.forEach(function (slide) {
            var video = slide.querySelector('.gift-shoppable-reel__video');
            if (!video) return;
            if (slide === closest) {
              video.play().catch(function () {});
            } else {
              video.pause();
              video.currentTime = 0;
            }
          });
        }

        updateNav();
      }

      function scrollToIndex(idx, behavior) {
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        activeIndex = idx;
        var slide = slides[idx];
        var targetLeft = slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
        targetLeft = Math.max(0, Math.min(targetLeft, track.scrollWidth - track.clientWidth));
        track.scrollTo({ left: targetLeft, behavior: behavior || 'smooth' });
        updateActive();
      }

      function scrollByStep(dir) {
        scrollToIndex(activeIndex + dir);
      }

      function centerInitial() {
        var idx = Math.min(Math.floor(slides.length / 2), slides.length - 1);
        scrollToIndex(idx, 'auto');
      }

      if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
      if (next) next.addEventListener('click', function () { scrollByStep(1); });

      var dragging = false;
      var dragStartX = 0;
      var dragScrollLeft = 0;
      var dragMoved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('a, button, input')) return;
        dragging = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = e.clientX - dragStartX;
        if (Math.abs(delta) > 4) dragMoved = true;
        track.scrollLeft = dragScrollLeft - delta;
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (e && e.pointerId && track.hasPointerCapture(e.pointerId)) {
          track.releasePointerCapture(e.pointerId);
        }
        updateActive();
        if (dragMoved) scrollToIndex(activeIndex);
        dragMoved = false;
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (e) {
        if (!dragMoved) return;
        if (e.target.closest('a, button')) {
          e.preventDefault();
          e.stopPropagation();
        }
        dragMoved = false;
      }, true);

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollByStep(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollByStep(1);
        }
      });

      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = null;
          updateActive();
        });
      }, { passive: true });

      section.querySelectorAll('[data-shoppable-mute]').forEach(function (btn) {
        var video = btn.closest('.gift-shoppable-reel__media').querySelector('video');
        if (!video) return;
        btn.addEventListener('click', function () {
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        });
      });

      centerInitial();
      window.addEventListener('resize', updateActive);
    });
  }

  function initMediaSplit() {
    document.querySelectorAll('[data-gift-media-split]').forEach(function (wrap) {
      var video = wrap.querySelector('.gift-media-split__video');
      var dots = wrap.querySelectorAll('.gift-media-split__dot');
      var frames = wrap.querySelectorAll('[data-media-slide]');
      var track = wrap.querySelector('[data-media-track]');
      var count = parseInt(wrap.dataset.slideCount, 10) || 8;
      if (!dots.length) return;

      var followVideo = true;
      var activeIndex = 0;
      var userInteracting = false;
      var interactionTimer = null;
      var autoForwardTimer = null;
      var scrollSyncTimer = null;
      var programmaticScroll = false;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function markUserInteraction() {
        userInteracting = true;
        followVideo = false;
        clearTimeout(interactionTimer);
        interactionTimer = setTimeout(function () {
          userInteracting = false;
        }, 900);
      }

      function getVisibleIndex() {
        if (!track || !frames.length) return 0;
        var trackRect = track.getBoundingClientRect();
        var anchor = trackRect.left + Math.min(trackRect.width * 0.28, 180);
        var closest = 0;
        var closestDist = Infinity;

        frames.forEach(function (frame, index) {
          var rect = frame.getBoundingClientRect();
          var center = rect.left + rect.width * 0.5;
          var dist = Math.abs(center - anchor);
          if (dist < closestDist) {
            closestDist = dist;
            closest = index;
          }
        });

        return closest;
      }

      function stopAutoForward() {
        if (autoForwardTimer) {
          clearInterval(autoForwardTimer);
          autoForwardTimer = null;
        }
      }

      function startAutoForward(fromIndex) {
        if (reduceMotion || fromIndex >= count - 1) return;
        stopAutoForward();
        var idx = fromIndex;
        autoForwardTimer = setInterval(function () {
          if (userInteracting) return;
          idx = Math.min(count - 1, idx + 1);
          setActive(idx, { scroll: true });
          if (idx >= count - 1) stopAutoForward();
        }, 2300);
      }

      function syncFromScroll() {
        var visible = getVisibleIndex();
        setActive(visible, { scroll: false });
        if (visible >= 3) {
          followVideo = false;
          startAutoForward(visible);
        } else {
          stopAutoForward();
        }
      }

      if (track) {
        track.addEventListener('scroll', function () {
          if (!programmaticScroll) markUserInteraction();
          clearTimeout(scrollSyncTimer);
          scrollSyncTimer = setTimeout(syncFromScroll, 120);
        }, { passive: true });
        track.addEventListener('touchstart', markUserInteraction, { passive: true });
        track.addEventListener('wheel', markUserInteraction, { passive: true });
      }

      function slideDuration() {
        if (video && video.duration && !isNaN(video.duration)) return video.duration / count;
        return 2.3;
      }

      function setActive(index, options) {
        options = options || {};
        index = Math.max(0, Math.min(count - 1, index));
        var indexChanged = index !== activeIndex;
        activeIndex = index;

        dots.forEach(function (dot, i) {
          var isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        frames.forEach(function (frame) {
          var frameIndex = parseInt(frame.dataset.mediaSlide, 10) || 0;
          frame.classList.toggle('is-active', frameIndex === index);
        });

        if (
          track &&
          frames[index] &&
          indexChanged &&
          options.scroll !== false &&
          !userInteracting
        ) {
          programmaticScroll = true;
          var frame = frames[index];
          var targetLeft = frame.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left: targetLeft, behavior: 'smooth' });
          setTimeout(function () {
            programmaticScroll = false;
          }, 450);
        }
      }

      function syncFromVideo() {
        if (!followVideo || !video || userInteracting) return;
        var index = Math.floor(video.currentTime / slideDuration()) % count;
        if (index !== activeIndex) setActive(index);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.slide, 10) || 0;
          followVideo = index === 0;
          userInteracting = false;
          stopAutoForward();
          if (index === 0 && video) {
            video.currentTime = 0;
          }
          if (index >= 3) {
            startAutoForward(index);
          }
          setActive(index, { scroll: true });
        });
      });

      frames.forEach(function (frame) {
        frame.addEventListener('mouseenter', function () {
          var index = parseInt(frame.dataset.mediaSlide, 10) || 0;
          if (index > 0) followVideo = false;
          setActive(index, { scroll: false });
        });
      });

      if (video) {
        video.addEventListener('timeupdate', syncFromVideo);
        video.addEventListener('loadedmetadata', syncFromVideo);
      }

      setActive(0, { scroll: false });
    });
  }

  function initLetterOpen() {
    var letters = document.querySelectorAll('[data-gift-letter]');
    if (!letters.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollOpts = { passive: true };

    letters.forEach(function (letter) {
      if (reduceMotion) {
        letter.classList.add('is-open');
        return;
      }

      var target = letter.querySelector('.gift-letter__card') || letter;
      var hasScrolled = false;
      var isInView = false;

      function cardIsReady() {
        var rect = target.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var h = Math.max(rect.height, 1);
        var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        var ratio = visible / h;
        var centerY = rect.top + h * 0.5;
        return ratio >= 0.48 && centerY >= vh * 0.36 && centerY <= vh * 0.74;
      }

      function resetLetter() {
        isInView = false;
        letter.classList.remove('is-open');
        letter.querySelectorAll('.gift-letter__char').forEach(function (char) {
          char.style.animation = 'none';
        });
        void letter.offsetWidth;
        letter.querySelectorAll('.gift-letter__char').forEach(function (char) {
          char.style.animation = '';
        });
      }

      function playLetter() {
        if (isInView || !hasScrolled || !cardIsReady()) return;
        isInView = true;
        letter.classList.add('is-open');
      }

      function syncLetter() {
        if (!hasScrolled) return;
        if (cardIsReady()) {
          if (!isInView) playLetter();
        } else if (isInView) {
          resetLetter();
        }
      }

      function onUserScroll() {
        hasScrolled = true;
        syncLetter();
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function () {
            syncLetter();
          },
          { threshold: [0, 0.35, 0.48, 0.6, 1], rootMargin: '0px 0px -8% 0px' }
        );
        observer.observe(target);
      }

      window.addEventListener('scroll', onUserScroll, scrollOpts);
      window.addEventListener('wheel', onUserScroll, scrollOpts);
      window.addEventListener('touchmove', onUserScroll, scrollOpts);
    });
  }

  function initNewsletter() {
    // The footer form posts and reloads; Shopify renders the success or error
    // message server side. Bring the result into view after the reload.
    var result = document.querySelector('#giftFooterForm .gift-footer__success, #giftFooterForm .gift-footer__error');
    if (result) {
      result.scrollIntoView({ block: 'center' });
    }
  }

  function initShopMethods() {
    document.querySelectorAll('[data-gift-shop-methods]').forEach(function (section) {
      var tabs = section.querySelectorAll('[data-method-tab]');
      var panels = section.querySelectorAll('[data-method-panel]');
      if (!tabs.length || !panels.length) return;

      function updatePanelCta(panel, filterBtn) {
        var cta = panel.querySelector('[data-method-cta]');
        if (!cta || !filterBtn) return;
        var label = filterBtn.getAttribute('data-cta-label');
        var link = filterBtn.getAttribute('data-cta-link');
        if (label) cta.textContent = label;
        if (link) cta.setAttribute('href', link);
      }

      function applyFilter(panel, filterBtn) {
        var filterKey = filterBtn.getAttribute('data-method-filter');
        var products = panel.querySelectorAll('[data-method-products] .gift-shop-methods__product');
        var shown = 0;

        products.forEach(function (item) {
          var itemKey = item.getAttribute('data-filter-key') || 'all';
          var visible = itemKey === filterKey || itemKey === 'all';
          if (visible && shown < 3) {
            item.hidden = false;
            item.classList.remove('is-filter-hidden');
            shown += 1;
          } else {
            item.hidden = true;
            item.classList.add('is-filter-hidden');
          }
        });

        panel.querySelectorAll('[data-method-filter]').forEach(function (btn) {
          var active = btn === filterBtn;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        updatePanelCta(panel, filterBtn);
      }

      function resetPanelFilters(panel) {
        var firstFilter = panel.querySelector('[data-method-filter]');
        if (firstFilter) applyFilter(panel, firstFilter);
      }

      function activateTab(tab) {
        var id = tab.getAttribute('data-method-tab');
        var scrollX = window.scrollX;
        var scrollY = window.scrollY;

        tabs.forEach(function (other) {
          var active = other === tab;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-method-panel') === id;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) resetPanelFilters(panel);
        });

        requestAnimationFrame(function () {
          window.scrollTo(scrollX, scrollY);
        });
      }

      panels.forEach(function (panel) {
        panel.querySelectorAll('[data-method-filter]').forEach(function (filterBtn) {
          filterBtn.addEventListener('click', function () {
            applyFilter(panel, filterBtn);
          });
        });
        resetPanelFilters(panel);
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('mouseenter', function () {
          activateTab(tab);
        });
        tab.addEventListener('click', function () {
          activateTab(tab);
        });
      });
    });
  }

  function initShopCatalogControls() {
    document.querySelectorAll('[data-gift-shop-toolbar]').forEach(function (toolbar) {
      var shopInner = toolbar.closest('.gift-shop__inner');
      if (!shopInner) return;

      var grid = shopInner.querySelector('[data-shop-grid]');
      var sortSelect = toolbar.querySelector('[data-shop-sort]');
      var sortLabel = toolbar.querySelector('[data-shop-sort-label]');
      var countEl = toolbar.querySelector('[data-shop-result-count]');
      if (!grid) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-plp-card]'));
      cards.forEach(function (card, index) {
        card.setAttribute('data-sort-order', String(index));
      });

      function visibleCount() {
        return cards.filter(function (card) { return !card.hidden; }).length;
      }

      function updateCount() {
        if (!countEl) return;
        var visible = visibleCount();
        countEl.textContent = visible + ' product' + (visible === 1 ? '' : 's');
      }

      function cardTitle(card) {
        return (card.getAttribute('data-sort-title') || '').toLowerCase();
      }

      function cardPrice(card) {
        var cents = parseInt(card.getAttribute('data-sort-price') || '0', 10);
        if (cents > 0) return cents;
        var priceEl = card.querySelector('.gift-shop-card__price');
        return parsePriceCents(priceEl ? priceEl.textContent : '');
      }

      function sortCards(key) {
        var sorted = cards.slice().sort(function (a, b) {
          if (key === 'featured') {
            return parseInt(a.getAttribute('data-sort-order') || '0', 10) - parseInt(b.getAttribute('data-sort-order') || '0', 10);
          }
          if (key === 'title-asc') return cardTitle(a).localeCompare(cardTitle(b));
          if (key === 'title-desc') return cardTitle(b).localeCompare(cardTitle(a));
          if (key === 'price-asc') return cardPrice(a) - cardPrice(b);
          if (key === 'price-desc') return cardPrice(b) - cardPrice(a);
          return 0;
        });
        sorted.forEach(function (card) {
          grid.appendChild(card);
        });
      }

      // The grid density toggle was dropped from the toolbar, so the column
      // count is whatever the section markup renders (gift-shop-grid--cols-3).
      // A stale gift-plp-grid-cols preference from the old control is ignored
      // rather than replayed, or a shopper who once chose 2-up would be stuck
      // there with no control left to change it back.

      function syncSortLabel() {
        if (!sortLabel || !sortSelect) return;
        var chosen = sortSelect.options[sortSelect.selectedIndex];
        if (chosen) sortLabel.textContent = chosen.text;
      }

      if (sortSelect) {
        // The select is transparent, so the span is what a shopper reads. Sync
        // it on load too: a reload can restore a selection the markup does not
        // have, and the label would then name the wrong sort.
        syncSortLabel();
        sortSelect.addEventListener('change', function () {
          sortCards(sortSelect.value);
          syncSortLabel();
        });
      }

      toolbar.giftUpdateCatalogCount = updateCount;
      updateCount();
    });
  }

  function initShopFilters() {
    document.querySelectorAll('[data-gift-shop-filters]').forEach(function (nav) {
      var shopInner = nav.closest('.gift-shop__inner');
      if (!shopInner) return;

      var grid = shopInner.querySelector('.gift-shop-grid');
      var countEl = shopInner.querySelector('[data-shop-result-count]');
      var filters = nav.querySelectorAll('[data-shop-filter]');
      if (!grid || !filters.length) return;

      var cards = grid.querySelectorAll('[data-product-category]');
      if (!cards.length) return;

      function applyFilter(key, options) {
        options = options || {};
        var visible = 0;

        filters.forEach(function (btn) {
          var active = btn.getAttribute('data-shop-filter') === key;
          btn.classList.toggle('is-active', active);
          if (btn.getAttribute('role') === 'tab') {
            btn.setAttribute('aria-selected', active ? 'true' : 'false');
          }
        });

        cards.forEach(function (card) {
          var category = card.getAttribute('data-product-category') || '';
          var show = key === 'all' || category === key;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (countEl) {
          countEl.textContent = visible + ' product' + (visible === 1 ? '' : 's');
        }

        var toolbar = shopInner.querySelector('[data-gift-shop-toolbar]');
        if (toolbar && toolbar.giftUpdateCatalogCount) {
          toolbar.giftUpdateCatalogCount();
        }

        if (!options.silent) {
          var params = new URLSearchParams(window.location.search);
          if (key === 'all') params.delete('category');
          else params.set('category', key);
          var nextUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
          window.history.replaceState({}, '', nextUrl);
        }
      }

      filters.forEach(function (btn) {
        if (btn.tagName === 'BUTTON') {
          btn.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            e.preventDefault();
          });
        }

        btn.addEventListener('click', function (e) {
          if (btn.tagName === 'A') e.preventDefault();
          var scrollX = window.scrollX;
          var scrollY = window.scrollY;
          applyFilter(btn.getAttribute('data-shop-filter'));
          requestAnimationFrame(function () {
            window.scrollTo(scrollX, scrollY);
          });
        });
      });

      var initialCategory = new URLSearchParams(window.location.search).get('category');
      if (initialCategory) {
        var hasInitialFilter = Array.prototype.some.call(filters, function (btn) {
          return btn.getAttribute('data-shop-filter') === initialCategory;
        });
        if (hasInitialFilter) {
          applyFilter(initialCategory, { silent: true });
          var shopGrid = document.getElementById('shop-grid');
          if (shopGrid) {
            window.requestAnimationFrame(function () {
              shopGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }
        }
      }
    });
  }

  var careLearnEscBound = false;

  // Opens a tutorial's Shopify-hosted video in a popup player. The <video> lives
  // in a <template> next to its tile, so nothing downloads until the tile is
  // clicked, and emptying the stage on close destroys the element and stops
  // playback outright.
  function initCareLearnVideo(root) {
    var modal = root.querySelector('[data-care-learn-modal]');
    var stage = root.querySelector('[data-care-learn-modal-stage]');
    if (!modal || !stage || modal.dataset.careLearnBound === '1') return;
    modal.dataset.careLearnBound = '1';

    var lastFocused = null;

    function templateFor(id) {
      var found = null;
      root.querySelectorAll('[data-care-learn-video-source]').forEach(function (tpl) {
        if (tpl.getAttribute('data-care-learn-video-source') === id) found = tpl;
      });
      return found;
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gift-care-learn-modal-open');
      stage.innerHTML = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }

    function openModal(trigger) {
      var tpl = templateFor(trigger.getAttribute('data-care-learn-video'));
      if (!tpl) return;

      // An arrow inside the player is about to be replaced along with the clip,
      // so focus should still go back to the tile that first opened the popup.
      if (!stage.contains(trigger)) lastFocused = trigger;
      stage.innerHTML = '';
      stage.appendChild(tpl.content.cloneNode(true));

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      // Force a reflow with the element visible so the fade actually runs.
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('gift-care-learn-modal-open');

      var video = stage.querySelector('video');
      if (video) {
        video.controls = true;
        video.playsInline = true;
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {
            // Browsers refuse to autoplay with sound. Falling back to muted keeps
            // the clip starting on open; the controls let the viewer unmute.
            video.muted = true;
            var retry = video.play();
            if (retry && typeof retry.catch === 'function') retry.catch(function () {});
          });
        }
      }

      var closeBtn = modal.querySelector('.gift-care-learn__modal-close');
      if (closeBtn) closeBtn.focus();
    }

    root.addEventListener('click', function (event) {
      var closer = event.target.closest('[data-care-learn-modal-close]');
      if (closer) {
        event.preventDefault();
        closeModal();
        return;
      }
      var trigger = event.target.closest('[data-care-learn-video]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
      }
    });

    modal.careLearnClose = closeModal;

    if (!careLearnEscBound) {
      careLearnEscBound = true;
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-care-learn-modal]').forEach(function (openModalEl) {
          if (typeof openModalEl.careLearnClose === 'function') openModalEl.careLearnClose();
        });
      });
    }
  }

  function initCareLearn() {
    document.querySelectorAll('[data-gift-care-learn]').forEach(function (root) {
      initCareLearnVideo(root);

      var filters = root.querySelectorAll('[data-care-learn-filter]');
      var items = root.querySelectorAll('[data-tutorial-category]');
      if (!filters.length || !items.length) return;
      if (root.dataset.careLearnFiltersBound === '1') return;
      root.dataset.careLearnFiltersBound = '1';

      function applyFilter(key) {
        filters.forEach(function (btn) {
          var active = btn.getAttribute('data-care-learn-filter') === key;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        items.forEach(function (item) {
          var category = item.getAttribute('data-tutorial-category') || '';
          var show = key === 'all' || category === key;
          item.hidden = !show;
        });
      }

      filters.forEach(function (btn) {
        btn.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          e.preventDefault();
        });
        btn.addEventListener('click', function () {
          var scrollX = window.scrollX;
          var scrollY = window.scrollY;
          applyFilter(btn.getAttribute('data-care-learn-filter'));
          requestAnimationFrame(function () {
            window.scrollTo(scrollX, scrollY);
          });
        });
      });
    });
  }

  function initDemoPageFallback() {
    var path = window.location.pathname.replace(/\/$/, '');
    var pageRoutes = {
      '/pages/care-and-learn': {
        selector: '[data-page-fallback="care-and-learn"]',
        title: 'Care & Learn \u2013 Gift Hair Extensions'
      }
    };
    var config = pageRoutes[path];
    if (!config) return;

    var page = document.querySelector(config.selector);
    if (!page) return;

    var copy = document.querySelector('[data-demo-fallback-copy]');
    var section404 = document.querySelector('.gift-404');
    if (copy) copy.hidden = true;
    if (section404) section404.classList.add('gift-404--page-demo');

    page.hidden = false;
    page.classList.add('is-active');
    document.title = config.title;
  }

  function themeAssetUrl(filename) {
    if (!filename) return '';
    var script = document.querySelector('script[src*="gift-brand.js"]');
    if (script && script.src) return script.src.replace(/gift-brand\.js.*$/, filename);
    return filename;
  }

  function galleryItemsFromFiles(files, titlePrefix) {
    return (files || []).map(function (file, index) {
      return {
        type: 'image',
        src: themeAssetUrl(file),
        id: 'demo-' + (index + 1)
      };
    }).filter(function (item) { return item.src; });
  }

  function fentySpecsHtml() {
    return '<dl class="gift-pdp__specs">' +
      '<div class="gift-pdp__specs-item"><dt>Hair</dt><dd>100% Virgin</dd></div>' +
      '<div class="gift-pdp__specs-item"><dt>Lengths</dt><dd>18&quot; &mdash; 20&quot;</dd></div>' +
      '<div class="gift-pdp__specs-item"><dt>Wear</dt><dd>12+ months</dd></div>' +
      '<div class="gift-pdp__specs-item"><dt>Care</dt><dd>Every 2&ndash;3 weeks</dd></div>' +
    '</dl>';
  }

  function fentyOptionLegend(optionName, index, selectedValue) {
    return '<legend class="gift-pdp__option-label gift-pdp__option-label--fenty">' +
      '<span class="gift-pdp__option-name">' + optionName.toUpperCase() + '</span>' +
      '<span class="gift-pdp__option-sep" aria-hidden="true"> &middot; </span>' +
      '<span data-selected-label="' + index + '">' + selectedValue + '</span>' +
    '</legend>';
  }

  function renderPdpGalleryParts(galleryItems, productTitle) {
    var safeTitle = (productTitle || '').replace(/"/g, '&quot;');
    var thumbsHtml = galleryItems.map(function (item, index) {
      var thumbSrc = item.type === 'video' ? (item.poster || item.src) : item.src;
      var videoClass = item.type === 'video' ? ' gift-pdp__thumb--video' : '';
      return '<button type="button" class="gift-pdp__thumb' + (index === 0 ? ' is-active' : '') + videoClass + '" data-thumb="' + item.id + '" aria-label="View image ' + (index + 1) + '"><img src="' + thumbSrc + '" alt="" class="gift-pdp__thumb-img" loading="lazy"></button>';
    }).join('');

    var mediaHtml = galleryItems.map(function (item, index) {
      if (item.type === 'video') {
        return '<div class="gift-pdp__media' + (index === 0 ? ' is-active' : '') + '" data-media-id="' + item.id + '"><video class="gift-pdp__img" controls playsinline preload="metadata"' + (item.poster ? ' poster="' + item.poster + '"' : '') + '><source src="' + item.src + '" type="video/mp4"></video></div>';
      }
      return '<div class="gift-pdp__media' + (index === 0 ? ' is-active' : '') + '" data-media-id="' + item.id + '"><img src="' + item.src + '" alt="' + safeTitle + '" class="gift-pdp__img" loading="' + (index === 0 ? 'eager' : 'lazy') + '"></div>';
    }).join('');

    return { thumbsHtml: thumbsHtml, mediaHtml: mediaHtml };
  }

  function renderAsSeenHtml(imageUrls) {
    return (imageUrls || []).filter(Boolean).map(function (src) {
      return '<figure class="gift-pdp__as-seen-item"><img src="' + src + '" alt="" class="gift-pdp__as-seen-img" width="300" height="400" loading="lazy"></figure>';
    }).join('');
  }

  function bindPdpGalleryControls(root) {
    var scope = root || document;
    var mediaEls = Array.prototype.slice.call(scope.querySelectorAll('.gift-pdp__media'));
    var thumbEls = Array.prototype.slice.call(scope.querySelectorAll('[data-thumb]'));
    var stage = scope.querySelector('.gift-pdp__stage');

    function pauseGalleryVideos() {
      scope.querySelectorAll('.gift-pdp__media video').forEach(function (video) {
        video.pause();
      });
    }

    function setActiveMedia(index) {
      if (!mediaEls.length) return;
      pauseGalleryVideos();
      var i = ((index % mediaEls.length) + mediaEls.length) % mediaEls.length;
      var id = mediaEls[i].getAttribute('data-media-id');
      mediaEls.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
      });
      thumbEls.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-thumb') === id);
      });
    }

    thumbEls.forEach(function (btn, index) {
      btn.onclick = function () {
        setActiveMedia(index);
      };
    });

    var prevBtn = scope.querySelector('[data-gallery-prev]');
    var nextBtn = scope.querySelector('[data-gallery-next]');
    if (prevBtn) {
      prevBtn.onclick = function () {
        var current = mediaEls.findIndex(function (el) { return el.classList.contains('is-active'); });
        setActiveMedia(current - 1);
      };
    }
    if (nextBtn) {
      nextBtn.onclick = function () {
        var current = mediaEls.findIndex(function (el) { return el.classList.contains('is-active'); });
        setActiveMedia(current + 1);
      };
    }

    if (stage && mediaEls.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      stage.ontouchstart = function (e) {
        if (!e.changedTouches.length) return;
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      };
      stage.ontouchend = function (e) {
        if (!e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var current = mediaEls.findIndex(function (el) { return el.classList.contains('is-active'); });
        setActiveMedia(current + (dx < 0 ? 1 : -1));
      };
    }
  }

  function initPdpColorGallery(product) {
    if (!product.galleries_by_color) return;

    var section = document.getElementById('giftPdp');
    var form = document.getElementById('giftPdpForm');
    if (!section || !form) return;

    function galleryFilesForColor(color) {
      return product.galleries_by_color[color] || product.galleries_by_color[product.default_color] || [];
    }

    function asSeenForColor(color) {
      if (product.as_seen_by_color && product.as_seen_by_color[color]) {
        return product.as_seen_by_color[color].map(themeAssetUrl).filter(Boolean);
      }
      return [];
    }

    function applyColorGallery(color) {
      var scrollY = window.scrollY;
      var galleryItems = galleryItemsFromFiles(galleryFilesForColor(color), product.title);
      var parts = renderPdpGalleryParts(galleryItems, product.title);
      var thumbsCol = section.querySelector('[data-pdp-thumbs]');
      var stageMedia = section.querySelector('[data-pdp-stage-media]');
      var asSeenGrid = section.querySelector('[data-pdp-as-seen-grid]');

      if (thumbsCol) thumbsCol.innerHTML = parts.thumbsHtml;
      if (stageMedia) stageMedia.innerHTML = parts.mediaHtml;
      if (asSeenGrid) asSeenGrid.innerHTML = renderAsSeenHtml(asSeenForColor(color));

      bindPdpGalleryControls(section);
      window.requestAnimationFrame(function () {
        window.scrollTo(0, scrollY);
      });
    }

    form.querySelectorAll('[data-option-input][data-option-index="0"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        applyColorGallery(input.value);
      });
    });
  }

  function demoPriceRange(item) {
    if (item.price_max && item.price_max > item.price) {
      return money(item.price) + ' \u2013 ' + money(item.price_max);
    }
    return money(item.price);
  }

  function buildDemoHandpickedCard(handle, item) {
    var imgSrc = themeAssetUrl(item.image);
    var badge = item.badge ? '<span class="gift-shop-card__badge">' + escapeHtml(item.badge) + '</span>' : '';
    var title = escapeHtml(item.title || handle);
    var price = escapeHtml(demoPriceRange(item));
    var pdpUrl = '/products/' + encodeURIComponent(handle);
    return '<article class="gift-shop-card gift-shop-card--gisou gift-shop-card--carousel" data-plp-card data-demo-product-card data-card-uid="' + escapeAttr(handle) + '">' +
      '<div class="gift-shop-card__media-wrap"><a href="' + pdpUrl + '" class="gift-shop-card__media">' +
        (imgSrc ? '<img class="gift-shop-card__img" src="' + escapeAttr(imgSrc) + '" alt="' + title + '" width="400" height="500" loading="lazy">' : '') +
        badge + '</a></div>' +
      '<div class="gift-shop-card__body">' +
        '<h3 class="gift-shop-card__title"><a href="' + pdpUrl + '">' + title + '</a></h3>' +
        '<div class="gift-shop-card__price"><span>' + price + '</span></div>' +
        '<div class="gift-shop-card__footer"><a href="' + pdpUrl + '" class="gift-shop-card__action"><span class="gift-shop-card__action-label">Shop now</span></a></div>' +
      '</div></article>';
  }

  function buildDemoHandpickedHtml(catalog, currentHandle) {
    var cards = Object.keys(catalog).filter(function (key) { return key !== currentHandle; }).map(function (key) {
      return buildDemoHandpickedCard(key, catalog[key]);
    }).join('');
    return '<section class="gift-pdp-handpicked" id="giftPdpHandpicked"><div class="gift-pdp-handpicked__inner">' +
      '<div class="gift-pdp-handpicked__head"><h2 class="gift-pdp-handpicked__title">Handpicked for you</h2>' +
        '<div class="gift-pdp-handpicked__nav">' +
          '<button type="button" class="gift-pdp-handpicked__nav-btn" data-carousel-prev aria-label="Previous products">&larr;</button>' +
          '<button type="button" class="gift-pdp-handpicked__nav-btn" data-carousel-next aria-label="Next products">&rarr;</button>' +
        '</div></div>' +
      '<div class="gift-carousel-wrap gift-carousel-wrap--pdp-handpicked">' +
        '<div class="gift-carousel gift-carousel--products" data-carousel>' + cards + '</div>' +
      '</div></div></section>';
  }

  function buildDemoQuizBannerHtml(mount) {
    if (!GIFT_PDP_FEATURES.quizBanner) return '';

    var quizImg = mount.getAttribute('data-demo-quiz-img') || '';
    return '<section class="gift-campaign-banner gift-campaign-banner--split gift-campaign-banner--dark gift-campaign-banner--focus-center gift-pdp-quiz" id="quiz">' +
      '<div class="gift-campaign-banner__media">' +
        (quizImg ? '<img src="' + escapeAttr(quizImg) + '" alt="Five questions, one match." class="gift-campaign-banner__img" width="758" height="426" loading="lazy">' : '') +
      '</div>' +
      '<div class="gift-campaign-banner__panel"><div class="gift-campaign-banner__content">' +
        '<p class="gift-campaign-banner__eyebrow">The Gift Quiz · 5 minutes</p>' +
        '<h2 class="gift-campaign-banner__title">Five questions, one match.</h2>' +
        '<p class="gift-campaign-banner__text">One clear recommendation — the exact match, your length, how to measure, and everything you&rsquo;ll need to make it yours.</p>' +
        '<a href="/pages/quiz" class="gift-campaign-banner__cta">Start the quiz</a>' +
      '</div></div></section>';
  }

  function initDemoProductFallback() {
    var mount = document.getElementById('giftDemoPdpMount');
    if (!mount) return;

    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!match) return;

    var handle = decodeURIComponent(match[1]);
    var catalogUrl = mount.getAttribute('data-demo-catalog');
    if (!catalogUrl) return;

    fetch(catalogUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('catalog');
        return res.json();
      })
      .then(function (catalog) {
        var product = catalog[handle];
        if (!product) return;

        var defaultColor = product.default_color || (product.colors && product.colors[0]) || 'Red';
        var galleryItems = [];
        if (product.galleries_by_color) {
          galleryItems = galleryItemsFromFiles(product.galleries_by_color[defaultColor], product.title);
        } else if (product.gallery && product.gallery.length) {
          galleryItems = galleryItemsFromFiles(product.gallery, product.title);
        } else {
          galleryItems = [
            { type: 'image', src: mount.getAttribute('data-demo-img-1'), id: 'demo-1' },
            { type: 'image', src: mount.getAttribute('data-demo-img-2'), id: 'demo-2' },
            { type: 'image', src: mount.getAttribute('data-demo-img-3'), id: 'demo-3' },
            { type: 'image', src: mount.getAttribute('data-demo-img-4'), id: 'demo-4' },
            { type: 'image', src: mount.getAttribute('data-demo-img-7'), id: 'demo-7' },
            {
              type: 'video',
              src: mount.getAttribute('data-demo-video'),
              poster: mount.getAttribute('data-demo-img-8'),
              id: 'demo-8'
            }
          ].filter(function (item) { return item.src; });
        }

        if (!galleryItems.length) {
          galleryItems = galleryItemsFromFiles([product.image], product.title);
        }

        var asSeenImages = [];
        if (product.as_seen_by_color && product.as_seen_by_color[defaultColor]) {
          asSeenImages = product.as_seen_by_color[defaultColor].map(themeAssetUrl).filter(Boolean);
        } else if (product.as_seen && product.as_seen.length) {
          asSeenImages = product.as_seen.map(themeAssetUrl).filter(Boolean);
        } else {
          asSeenImages = [
            mount.getAttribute('data-demo-as-seen-1'),
            mount.getAttribute('data-demo-as-seen-2'),
            mount.getAttribute('data-demo-as-seen-3'),
            mount.getAttribute('data-demo-as-seen-4')
          ].filter(Boolean);
        }

        var tagline = String(product.tagline || '').trim();
        var taglineHtml = tagline ? '<p class="gift-pdp__subtitle">' + escapeHtml(tagline) + '</p>' : '';
        var descriptionHtml = product.description
          ? '<div class="gift-pdp__excerpt"><div class="gift-pdp__excerpt-short rte">' + product.description + '</div></div>'
          : '';
        var useFentyBody = !!product.galleries_by_color;
        var bodyHtml = descriptionHtml;
        var priceHtml = product.price_max && product.price_max > product.price
          ? '<span>' + money(product.price) + ' \u2013 ' + money(product.price_max) + '</span>'
          : product.compare_at_price && product.compare_at_price > product.price
            ? '<span class="gift-pdp__price-sale">' + money(product.price) + '</span><span class="gift-pdp__price-compare"><s>' + money(product.compare_at_price) + '</s></span>'
            : '<span>' + money(product.price) + '</span>';

        var galleryParts = renderPdpGalleryParts(galleryItems, product.title);
        var thumbsHtml = galleryParts.thumbsHtml;
        var mediaHtml = galleryParts.mediaHtml;
        var asSeenHtml = renderAsSeenHtml(asSeenImages);

        var upsell1Image = mount.getAttribute('data-demo-upsell-1') || '';
        var upsell2Image = mount.getAttribute('data-demo-upsell-2') || '';
        var upsellHtml = '';
        if (GIFT_PDP_FEATURES.perfectGiftUpsell) {
          upsellHtml =
            '<div class="gift-pdp__upsell">' +
              '<h2 class="gift-pdp__upsell-heading">The Perfect Gift</h2>' +
              '<p class="gift-pdp__upsell-text">Add accessories to complete your look — brushes, scarves, and care essentials.</p>' +
              '<div class="gift-pdp__upsell-grid">' +
                '<article class="gift-pdp__upsell-card"><a href="' + GIFT_DEMO_PDP_URL + '" class="gift-pdp__upsell-media"><img src="' + upsell1Image + '" alt="Gift Care Kit" class="gift-pdp__upsell-img" width="400" height="500" loading="lazy"></a><div class="gift-pdp__upsell-copy"><h3 class="gift-pdp__upsell-title"><a href="' + GIFT_DEMO_PDP_URL + '">Gift Care Kit</a></h3><p class="gift-pdp__upsell-price">$48</p><form method="post" action="/cart/add" class="gift-pdp__upsell-form" data-demo-product data-demo-title="Gift Care Kit" data-demo-price="$48" data-demo-url="' + GIFT_DEMO_PDP_URL + '" data-demo-image="' + escapeAttr(upsell1Image) + '"><input type="hidden" name="id" value="demo-silk-scarf"><button type="submit" class="gift-btn gift-btn--secondary gift-pdp__upsell-add">Add</button></form></div></article>' +
                '<article class="gift-pdp__upsell-card"><a href="' + GIFT_DEMO_PDP_URL + '" class="gift-pdp__upsell-media"><img src="' + upsell2Image + '" alt="Silk Straight Ponytail" class="gift-pdp__upsell-img" width="400" height="500" loading="lazy"></a><div class="gift-pdp__upsell-copy"><h3 class="gift-pdp__upsell-title"><a href="' + GIFT_DEMO_PDP_URL + '">Silk Straight Ponytail</a></h3><p class="gift-pdp__upsell-price">$185</p><form method="post" action="/cart/add" class="gift-pdp__upsell-form" data-demo-product data-demo-title="Silk Straight Ponytail" data-demo-price="$185" data-demo-url="' + GIFT_DEMO_PDP_URL + '" data-demo-image="' + escapeAttr(upsell2Image) + '"><input type="hidden" name="id" value="demo-ponytail-extension"><button type="submit" class="gift-btn gift-btn--secondary gift-pdp__upsell-add">Add</button></form></div></article>' +
              '</div>' +
            '</div>';
        }

        var variants = [];
        var colors = product.colors && product.colors.length ? product.colors : ['Cool Ash Blonde', 'Dark Brown'];
        var lengths = ['18"', '20"'];
        var densities = ['2 Bundles', '3 Bundles'];
        var sizes = ['Small', 'Medium'];
        var variantIndex = 0;

        colors.forEach(function (color) {
          lengths.forEach(function (length) {
            densities.forEach(function (density) {
              sizes.forEach(function (size) {
                var price = product.price;
                if (color === 'Gold' || color === 'Cool Ash Blonde') price += 3000;
                if (color === 'Dark Brown') price -= 5000;
                if (length === '20"') price += 3000;
                if (density === '3 Bundles') price += 10000;
                if (size === 'Medium') price += 5000;
                variants.push({
                  id: 'demo-variant-' + (++variantIndex),
                  title: color + ' / ' + length + ' / ' + density + ' / ' + size,
                  price: Math.max(0, price),
                  compare_at_price: null,
                  options: [color, length, density, size]
                });
              });
            });
          });
        });

        var colorSwatchesHtml = colors.map(function (color) {
          var checked = color === defaultColor ? ' checked' : '';
          return '<label class="gift-pdp__swatch" title="' + escapeAttr(color) + '">' +
            '<input type="radio" name="options[Color]" value="' + escapeAttr(color) + '"' + checked + ' data-option-input data-option-index="0">' +
            '<span class="gift-pdp__swatch-face">' + colorSwatchHtml(color) + '</span>' +
            '<span class="gift-pdp__swatch-label">' + escapeHtml(color) + '</span>' +
          '</label>';
        }).join('');

        var pdpLayoutClass = product.galleries_by_color ? ' gift-pdp--fenty' : '';
        var variantsJson = JSON.stringify(variants);
        var defaultVariantPrice = variants[0].price;
        var breadcrumbHtml = GIFT_PDP_FEATURES.breadcrumb && useFentyBody
          ? '<nav class="gift-pdp__breadcrumb" aria-label="Breadcrumb"><a href="/">Home</a><span class="gift-pdp__breadcrumb-sep" aria-hidden="true"> / </span><span aria-current="page">' + product.title + '</span></nav>'
          : '';
        var priceHtmlFenty = '<span>' + money(defaultVariantPrice) + '</span>';
        var priceRowHtml = useFentyBody
          ? '<div class="gift-pdp__price-row"><div class="gift-pdp__price" id="giftPdpPrice">' + priceHtmlFenty + '</div></div>'
          : '<div class="gift-pdp__price-row"><div class="gift-pdp__price" id="giftPdpPrice">' + priceHtml + '</div></div>';
        var specsHtml = useFentyBody ? fentySpecsHtml() : '';
        var formOptionsHtml = useFentyBody
          ? '<fieldset class="gift-pdp__option gift-pdp__option--color">' + fentyOptionLegend('Color', 0, defaultColor.toUpperCase()) +
              '<div class="gift-pdp__swatch-grid" role="group" aria-label="Color">' + colorSwatchesHtml + '</div></fieldset>' +
            '<fieldset class="gift-pdp__option gift-pdp__option--length">' + fentyOptionLegend('Length', 1, '18&quot;') +
              '<div class="gift-pdp__variant-grid gift-pdp__variant-grid--2" role="group" aria-label="Length">' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Length]" value="18&quot;" checked data-option-input data-option-index="1"><span>18&quot;</span></label>' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Length]" value="20&quot;" data-option-input data-option-index="1"><span>20&quot;</span></label>' +
              '</div></fieldset>' +
            '<fieldset class="gift-pdp__option gift-pdp__option--density">' + fentyOptionLegend('Density', 2, '2 BUNDLES') +
              '<div class="gift-pdp__variant-grid gift-pdp__variant-grid--2" role="group" aria-label="Density">' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Density]" value="2 Bundles" checked data-option-input data-option-index="2"><span>2 Bundles</span></label>' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Density]" value="3 Bundles" data-option-input data-option-index="2"><span>3 Bundles</span></label>' +
              '</div></fieldset>' +
            '<fieldset class="gift-pdp__option gift-pdp__option--size">' +
              '<div class="gift-pdp__option-header">' + fentyOptionLegend('Size', 3, 'SMALL') +
                '<button type="button" class="gift-pdp__size-guide" data-pdp-sizing-open>Size guide</button></div>' +
              '<div class="gift-pdp__variant-grid gift-pdp__variant-grid--2" role="group" aria-label="Size">' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Size]" value="Small" checked data-option-input data-option-index="3"><span>Small</span></label>' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Size]" value="Medium" data-option-input data-option-index="3"><span>Medium</span></label>' +
              '</div></fieldset>'
          : '<fieldset class="gift-pdp__option gift-pdp__option--color"><legend class="gift-pdp__option-label">Color: <span data-selected-label="0">' + defaultColor + '</span></legend>' +
              '<div class="gift-pdp__swatch-grid" role="group" aria-label="Color">' + colorSwatchesHtml + '</div></fieldset>' +
            '<fieldset class="gift-pdp__option gift-pdp__option--length"><legend class="gift-pdp__option-label">Length: <span data-selected-label="1">18&quot;</span></legend>' +
              '<div class="gift-pdp__variant-grid gift-pdp__variant-grid--2" role="group" aria-label="Length">' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Length]" value="18&quot;" checked data-option-input data-option-index="1"><span>18&quot;</span></label>' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Length]" value="20&quot;" data-option-input data-option-index="1"><span>20&quot;</span></label>' +
              '</div></fieldset>' +
            '<fieldset class="gift-pdp__option gift-pdp__option--density"><legend class="gift-pdp__option-label">Density: <span data-selected-label="2">2 Bundles</span></legend>' +
              '<div class="gift-pdp__variant-grid gift-pdp__variant-grid--2" role="group" aria-label="Density">' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Density]" value="2 Bundles" checked data-option-input data-option-index="2"><span>2 Bundles</span></label>' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Density]" value="3 Bundles" data-option-input data-option-index="2"><span>3 Bundles</span></label>' +
              '</div></fieldset>' +
            '<fieldset class="gift-pdp__option gift-pdp__option--size"><legend class="gift-pdp__option-label">Size: <span data-selected-label="3">Small</span></legend>' +
              '<div class="gift-pdp__variant-grid gift-pdp__variant-grid--2" role="group" aria-label="Size">' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Size]" value="Small" checked data-option-input data-option-index="3"><span>Small</span></label>' +
                '<label class="gift-pdp__variant-btn"><input type="radio" name="options[Size]" value="Medium" data-option-input data-option-index="3"><span>Medium</span></label>' +
              '</div></fieldset>';
        var utilityHtml = useFentyBody
          ? ''
          : '<div class="gift-pdp__utility"><button type="button" class="gift-pdp__utility-link gift-pdp__utility-btn" data-pdp-sizing-open>Find my size</button></div>';

        var qtyHtml = '<div class="gift-pdp__qty" data-pdp-qty><button type="button" class="gift-pdp__qty-btn" data-pdp-qty-dec aria-label="Decrease quantity">&minus;</button><input type="number" class="gift-pdp__qty-input" name="quantity" value="1" min="1" step="1" inputmode="numeric" aria-label="Quantity"><button type="button" class="gift-pdp__qty-btn" data-pdp-qty-inc aria-label="Increase quantity">+</button></div>';
        var atcBtnHtml = useFentyBody
          ? '<button type="submit" class="gift-btn gift-btn--primary gift-pdp__add" data-pdp-add-btn>ADD TO CART &mdash; <span data-pdp-add-price>' + money(defaultVariantPrice) + '</span></button>'
          : '<button type="submit" class="gift-btn gift-btn--primary gift-pdp__add">ADD TO CART</button>';
        var installmentHtml = useFentyBody
          ? '<p class="gift-pdp__installment gift-pdp__installment--footer" data-pdp-installment-footer>or 4 interest-free payments of ' + money(Math.round(defaultVariantPrice / 4)) + '</p>'
          : '';
        var actionsHtml = '<div class="gift-pdp__actions">' + qtyHtml + atcBtnHtml + '</div>' + installmentHtml;
        var titleHtml = useFentyBody
          ? '<h1 class="gift-pdp__title">' + escapeHtml(product.title) + '</h1>'
          : '';
        var demoFormAttrs = ' id="giftPdpForm" class="gift-pdp__form" data-demo-product novalidate method="post" action="/cart/add" data-demo-url="' + GIFT_DEMO_PDP_URL + '" data-demo-title="' + escapeAttr(product.title) + '"';
        var buyBoxInnerHtml = useFentyBody
          ? breadcrumbHtml +
            titleHtml +
            taglineHtml +
            descriptionHtml +
            priceRowHtml +
            specsHtml +
            '<form' + demoFormAttrs + '><input type="hidden" name="id" value="' + variants[0].id + '" id="giftPdpVariantId">' +
              formOptionsHtml +
              actionsHtml +
            '</form>'
          : '<h1 class="gift-pdp__title">' + product.title + '</h1>' +
            taglineHtml +
            '<div class="gift-pdp__price-row"><div class="gift-pdp__price" id="giftPdpPrice">' + priceHtml + '</div></div>' +
            bodyHtml +
            '<form' + demoFormAttrs + '><input type="hidden" name="id" value="' + variants[0].id + '" id="giftPdpVariantId">' +
              formOptionsHtml +
              actionsHtml +
            '</form>' +
            utilityHtml;

        var detailsHtml =
          upsellHtml +
          (asSeenHtml ? '<div class="gift-pdp__as-seen"><h2 class="gift-pdp__as-seen-title">As seen in real life</h2><div class="gift-pdp__as-seen-grid" data-pdp-as-seen-grid>' + asSeenHtml + '</div></div>' : '') +
          '<div class="gift-pdp__accordions" id="giftPdpDetails">' +
            '<div class="gift-pdp__accordion"><button type="button" class="gift-pdp__accordion-trigger" data-pdp-accordion-trigger aria-expanded="false"><span>Details</span><span class="gift-pdp__accordion-icon" aria-hidden="true"></span></button><div class="gift-pdp__accordion-panel" hidden><div class="gift-pdp__accordion-content rte"><p><strong>Construction:</strong> Machine-made with HD lace closure.</p><p><strong>Cap:</strong> Ventilated and breathable with adjustable straps.</p></div></div></div>' +
            '<div class="gift-pdp__accordion"><button type="button" class="gift-pdp__accordion-trigger" data-pdp-accordion-trigger aria-expanded="false"><span>Care</span><span class="gift-pdp__accordion-icon" aria-hidden="true"></span></button><div class="gift-pdp__accordion-panel" hidden><div class="gift-pdp__accordion-content rte"><ul><li>Wash gently with sulfate-free shampoo.</li><li>Heat style up to 450&deg;F / 230&deg;C.</li></ul></div></div></div>' +
            '<div class="gift-pdp__accordion"><button type="button" class="gift-pdp__accordion-trigger" data-pdp-accordion-trigger aria-expanded="false"><span>Shipping &amp; Returns</span><span class="gift-pdp__accordion-icon" aria-hidden="true"></span></button><div class="gift-pdp__accordion-panel" hidden><div class="gift-pdp__accordion-content rte"><p><strong>Processing</strong><br>Please allow 5&ndash;7 business days to process your order.</p><p><strong>Returns</strong><br>All sales are final on custom-made pieces.</p></div></div></div>' +
          '</div>';

        mount.innerHTML =
          '<section class="gift-pdp gift-pdp--lily gift-pdp--demo' + pdpLayoutClass + '" id="giftPdp">' +
            '<p class="gift-pdp__demo-note">Preview product — import demo products in Shopify Admin to enable checkout.</p>' +
            '<div class="gift-pdp__layout">' +
              '<div class="gift-pdp__gallery-col"><div class="gift-pdp__gallery">' +
                '<div class="gift-pdp__thumbs-col" data-pdp-thumbs role="tablist" aria-label="Product images">' + thumbsHtml + '</div>' +
                '<div class="gift-pdp__stage"><div class="gift-pdp__stage-media" data-pdp-stage-media>' + mediaHtml + '</div>' +
                  '<button type="button" class="gift-pdp__gallery-nav gift-pdp__gallery-nav--prev" data-gallery-prev aria-label="Previous image">&larr;</button>' +
                  '<button type="button" class="gift-pdp__gallery-nav gift-pdp__gallery-nav--next" data-gallery-next aria-label="Next image">&rarr;</button>' +
                '</div></div></div>' +
              '<div class="gift-pdp__buy-col"><div class="gift-pdp__buy-box">' + buyBoxInnerHtml + '</div></div>' +
              '<div class="gift-pdp__details-col">' + detailsHtml + '</div>' +
            '</div></section>' +
            '<div class="gift-pdp__sticky-bar" data-pdp-sticky hidden><div class="gift-pdp__sticky-inner"><div class="gift-pdp__sticky-info">' +
              '<p class="gift-pdp__sticky-title">' + product.title + '</p><p class="gift-pdp__sticky-price" id="giftPdpStickyPrice">' + money(product.price) + '</p></div>' +
              '<button type="button" class="gift-btn gift-btn--primary gift-pdp__sticky-add" data-sticky-atc>ADD TO CART</button></div></div>' +
            '<script type="application/json" id="giftPdpVariants">' + variantsJson + '<\/script>' +
            buildDemoHandpickedHtml(catalog, handle) +
            buildDemoQuizBannerHtml(mount);

        var copy = document.querySelector('[data-demo-fallback-copy]');
        var section = mount.closest('.gift-404');
        if (copy) copy.hidden = true;
        if (section) section.classList.add('gift-404--demo');
        mount.hidden = false;
        document.title = product.title + ' \u2013 Gift Hair Extensions';

        initPdp();
        initPdpSizingModal();
        bindPdpGalleryControls(document.getElementById('giftPdp'));
        initPdpColorGallery(product);
        initCarousel(mount);
      })
      .catch(function () {});
  }

  function initNavDropdownHover() {
    var headerWrap = document.getElementById('giftHeaderWrap');
    var header = document.querySelector('.gift-header--fenty');
    var nav = document.querySelector('.gift-header__nav');
    var flyout = document.getElementById('giftNavFlyout');
    if (!nav) return;

    var menuItems = nav.querySelectorAll('[data-nav-menu]');
    var megaItems = nav.querySelectorAll('.gift-header__nav-item--mega');
    var panels = flyout ? flyout.querySelectorAll('[data-nav-panel]') : [];
    var activeMenu = '';

    function positionFlyout(item) {
      if (!flyout || !header || !item) return;
      var headerRect = header.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      flyout.style.setProperty('--nav-flyout-left', (itemRect.left - headerRect.left) + 'px');
    }

    function setPanels(menuKey) {
      if (!flyout) return;
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-nav-panel') === menuKey;
        panel.classList.toggle('is-active', active);
        if (active) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      flyout.classList.toggle('is-open', !!menuKey);
      flyout.setAttribute('aria-hidden', menuKey ? 'false' : 'true');
    }

    function openMenu(menuKey, item) {
      if (!menuKey || !item) return;
      activeMenu = menuKey;
      menuItems.forEach(function (entry) {
        entry.classList.toggle('is-dropdown-open', entry === item);
      });
      megaItems.forEach(function (entry) {
        entry.classList.remove('is-dropdown-open');
      });
      positionFlyout(item);
      setPanels(menuKey);
    }

    function openMega(item) {
      activeMenu = '';
      menuItems.forEach(function (entry) {
        entry.classList.remove('is-dropdown-open');
      });
      megaItems.forEach(function (entry) {
        entry.classList.toggle('is-dropdown-open', entry === item);
      });
      setPanels('');
    }

    function closeAll() {
      activeMenu = '';
      menuItems.forEach(function (entry) {
        entry.classList.remove('is-dropdown-open');
      });
      megaItems.forEach(function (entry) {
        entry.classList.remove('is-dropdown-open');
      });
      setPanels('');
    }

    menuItems.forEach(function (item) {
      var link = item.querySelector('[data-nav-trigger]');
      var menuKey = item.getAttribute('data-nav-menu');
      if (!link || !menuKey) return;

      link.addEventListener('mouseenter', function () {
        openMenu(menuKey, item);
      });
    });

    megaItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        openMega(item);
      });
    });

    if (flyout) {
      flyout.addEventListener('mouseenter', function () {
        if (!activeMenu) return;
        menuItems.forEach(function (entry) {
          var isActive = entry.getAttribute('data-nav-menu') === activeMenu;
          entry.classList.toggle('is-dropdown-open', isActive);
          if (isActive) positionFlyout(entry);
        });
        setPanels(activeMenu);
      });
    }

    nav.querySelectorAll('a.gift-header__nav-link').forEach(function (link) {
      if (link.closest('[data-nav-menu]') || link.closest('.gift-header__nav-item--mega')) return;
      link.addEventListener('mouseenter', closeAll);
    });

    var leaveTarget = headerWrap || nav;
    leaveTarget.addEventListener('mouseleave', closeAll);

    menuItems.forEach(function (item) {
      item.addEventListener('focusin', function () {
        openMenu(item.getAttribute('data-nav-menu'), item);
      });

      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        if (flyout && flyout.contains(event.relatedTarget)) return;
        closeAll();
      });
    });
  }

  function initNavMegaShop() {
    document.querySelectorAll('[data-gift-nav-mega]').forEach(function (mega) {
      var tabs = mega.querySelectorAll('[data-mega-tab]');
      var panels = mega.querySelectorAll('[data-mega-panel]');

      function activateTab(tab) {
        var key = tab.getAttribute('data-mega-tab');
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-mega-panel') === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('mouseenter', function () {
          activateTab(tab);
        });
        tab.addEventListener('focus', function () {
          activateTab(tab);
        });
      });

      mega.querySelectorAll('[data-mega-scroll-next]').forEach(function (button) {
        button.addEventListener('click', function () {
          var track = button.closest('.gift-nav-mega__track-wrap');
          if (!track) return;
          var row = track.querySelector('[data-mega-track]');
          if (!row) return;
          var amount = Math.max(row.clientWidth * 0.75, 240);
          row.scrollBy({ left: amount, behavior: 'smooth' });
        });
      });
    });
  }

  function boot() {
    initHeaderOffset();
    initLogoHomeScroll();
    initNavDrawer();
    initNavDropdownHover();
    initNavMegaShop();
    initMiniCart();
    initAjaxAdd();
    initCarousel();
    initDemoProductFallback();
    initDemoPageFallback();
    initShopCardPreviews();
    initQuickAddDrawer();
    initPdp();
    initPdpSizingModal();
    initFooterAccordion();
    initMediaSplit();
    initShoppableReel();
    initShopMethods();
    initShopCatalogControls();
    initShopFilters();
    initCareLearn();
    initLetterOpen();
    initNewsletter();
    window.addEventListener('resize', initHeaderOffset);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // The theme editor re-renders a section on every setting change, discarding
  // the popup wiring along with the old markup.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-gift-care-learn]')) initCareLearn();
  });

  function bindPdpAfterSwap() {
    initPdp();
    initPdpSizingModal();
    initCarousel();
    initDemoProductFallback();
  }

  function loadLinkedProduct(href, scrollY, opts) {
    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      window.location.href = href;
      return;
    }
    url.hash = '';
    var nextHref = url.pathname + url.search;
    try { sessionStorage.setItem('gift:linked:scroll', String(scrollY || 0)); } catch (error) {}

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('linked product fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextMain = doc.querySelector('#MainContent');
        var currMain = document.querySelector('#MainContent');
        if (!nextMain || !currMain || !doc.querySelector('#giftPdp')) {
          throw new Error('linked product markup missing');
        }
        currMain.replaceWith(nextMain);
        document.title = doc.title;
        if (opts && opts.history) {
          history.pushState({ giftLinkedSwatch: true }, '', nextHref);
        }
        bindPdpAfterSwap();
        window.scrollTo(0, scrollY);
        window.requestAnimationFrame(function () {
          window.scrollTo(0, scrollY);
        });
        try { sessionStorage.removeItem('gift:linked:scroll'); } catch (error) {}
      })
      .catch(function () {
        window.location.href = nextHref;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest('a[data-linked-swatch]');
    if (!link) return;
    if (link.classList.contains('is-active')) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    loadLinkedProduct(link.href, window.scrollY || window.pageYOffset || 0, { history: true });
  }, true);

  window.addEventListener('popstate', function () {
    if (!document.getElementById('giftPdp') && !/\/products\//.test(location.pathname)) {
      window.location.reload();
      return;
    }
    if (!/\/products\//.test(location.pathname)) {
      window.location.reload();
      return;
    }
    loadLinkedProduct(location.href, window.scrollY || window.pageYOffset || 0, { history: false });
  });
})();

/* ==========================================================================
   Landing modules (TS-612): image carousel + offer popup.
   Self-contained IIFE appended after the existing bundle so none of the
   older init functions are touched. Both re-init on Shopify's theme editor
   section events so they keep working while a merchant edits the page.
   ========================================================================== */
(function () {
  'use strict';

  var CAROUSEL_SELECTOR = '[data-gift-carousel]';
  var MODAL_SELECTOR = '[data-gift-modal]';
  var DRAG_THRESHOLD = 40;

  function initCarousel(root) {
    if (!root || root.dataset.giftCarouselReady === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.gift-carousel__slide'));
    var dotsWrap = root.querySelector('[data-gift-carousel-dots]');
    if (slides.length === 0) return;
    root.dataset.giftCarouselReady = 'true';

    var interval = parseInt(root.dataset.interval, 10) || 4500;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var dots = [];

    // A single slide needs no dots, no autoplay and no drag.
    if (slides.length === 1) {
      slides[0].classList.add('is-active');
      return;
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gift-carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
      });
      dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.gift-carousel__dot'));
    }

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      restart();
    }

    function restart() {
      if (timer) clearInterval(timer);
      if (reduceMotion) return;
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }

    var startX = 0;
    var tracking = false;
    var wheelLock = false;

    root.addEventListener('pointerdown', function (e) {
      tracking = true;
      startX = e.clientX;
      root.classList.add('is-grabbing');
    });

    root.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      root.classList.remove('is-grabbing');
      var dx = e.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) goTo(index + (dx < 0 ? 1 : -1));
    });

    root.addEventListener('pointercancel', function () {
      tracking = false;
      root.classList.remove('is-grabbing');
    });

    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 18) return;
      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;
      goTo(index + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelLock = false; }, 450);
    }, { passive: false });

    restart();
  }

  var lastFocused = null;

  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('gift-modal-open');
    var closeBtn = modal.querySelector('.gift-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.classList.remove('gift-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function closeAllModals() {
    document.querySelectorAll(MODAL_SELECTOR + '.is-open').forEach(closeModal);
  }

  // Delegated so buttons and popups can live in different sections, and so a
  // section re-render in the theme editor never leaves a dead listener behind.
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-offer]');
    if (opener) {
      var target = opener.getAttribute('data-open-offer') || 'offer';
      var modal = document.querySelector('[data-gift-modal="' + target + '"]');
      if (modal) {
        e.preventDefault();
        openModal(modal);
      }
      return;
    }
    if (e.target.closest('[data-gift-modal-close]')) {
      closeModal(e.target.closest(MODAL_SELECTOR));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  });

  function initLandingModules(scope) {
    var root = scope || document;
    root.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLandingModules(); });
  } else {
    initLandingModules();
  }

  document.addEventListener('shopify:section:load', function (e) { initLandingModules(e.target); });
  document.addEventListener('shopify:section:unload', closeAllModals);
})();
